// Namespace i18n `recognition` (es) — REQ-099 / REQ-102 / REQ-103. Español es el idioma fuente.
const recognition = {
  // Armazon propio del modulo (menu lateral y cabecera): el portal no comparte estos textos.
  shell: {
    backToPortal: 'Volver al portal',
    collapseMenu: 'Contraer menú',
    expandMenu: 'Expandir menú',
    fundamentals: 'Fundamentales',
  },
  moduleTitle: 'Programa de Reconocimiento',
  nav: {
    recognize: 'Reconocer',
    shine: 'Brillamos Juntos',
    profile: 'Mi perfil',
    admin: 'Admin',
    team: 'Equipo',
    dashboard: 'Tablero',
    innovation: 'Innovación LATAM',
  },
  // F8 (paridad demo, H-96/H-97) — tab "Ver más" y menú del tab bar frontline móvil.
  frontlineMore: {
    tab: 'Ver más',
    title: 'Más opciones',
    documents: 'Documentos',
    language: 'Idioma',
    selectLanguage: 'Selecciona idioma',
  },
  common: {
    loading: 'Cargando…',
    error: 'No se pudo cargar la información.',
    retry: 'Reintentar',
    empty: 'No hay nada que mostrar todavía.',
    notConfigured: 'El servicio de reconocimiento no está configurado.',
    forbidden: 'No tienes permiso para ver esta sección.',
    close: 'Cerrar',
    remove: 'Quitar',
    cancel: 'Cancelar',
    insertEmoji: 'Insertar emoji',
    actions: 'Acciones',
  },
  recognize: {
    title: 'Reconocer a un compañero',
    subtitle: 'Agradece un comportamiento alineado a nuestros Fundamentales.',
    feedTitle: 'Reconocimientos recientes',
    feedEmpty: 'Aún no hay reconocimientos. ¡Sé el primero en reconocer!',
    newCta: 'Nuevo reconocimiento',
    form: {
      messagePlaceholder: 'Escribe tu mensaje de reconocimiento…',
      anonymous: 'Enviar de forma anónima',
      submit: 'Enviar reconocimiento',
    },
  },
  wall: {
    title: 'Muro de reconocimientos',
    count: '{{count}} reconocimientos',
    empty: 'Aún no hay reconocimientos para mostrar.',
    prev: 'Anteriores',
    next: 'Siguientes',
    pageOf: 'Página {{page}} de {{total}}',
    for: 'para',
    anonymous: 'Anónimo',
    senderHidden: 'Identidad no visible',
    points_one: '+{{count}} punto',
    points_other: '+{{count}} puntos',
    pointsTitle: 'Puntos que vale este reconocimiento',
    fundamentalsRecognized: 'Fundamentales reconocidos',
    fundIconTooltipAria: 'Ver todos los Fundamentales de este reconocimiento',
    behaviorsRecognized: 'Comportamientos reconocidos',
    habitsRecognized: 'Hábitos diarios reconocidos',
    detailUnavailable: 'No se pudo cargar el detalle completo.',
    reportCount: 'Reportado {{count}} vez/veces — en revisión',
    receivedIn: 'Recibido en:',
    antiSpoilerBlurredHint: 'Espera a la premiación del evento de Brillamos Juntos para ver tus nominaciones.',
  },
  reactions: {
    addLabel: 'Reaccionar',
    countLabel: '{{count}} reacciones',
    modalTitle: 'Reacciones',
    error: 'No se pudo guardar tu reacción. Inténtalo de nuevo.',
    whoReacted: 'Reaccionaron',
    whoLoading: 'Cargando…',
    whoEmpty: 'Nadie ha reaccionado todavía.',
    whoError: 'No se pudo cargar la lista.',
  },
  origin: {
    diario: 'Diario',
    brillamos: 'Brillamos',
    personalizada: 'Campaña',
    csv: 'Carga masiva',
    delegado: 'Delegado',
    sistema: 'Sistema',
  },
  panel: {
    title: 'Reconoce a tus compañeros',
    recipientsLabel: 'Personas',
    recipientsPlaceholder: 'Buscar por nombre…',
    searchError: 'No se pudo buscar personas',
    fundamentalLabel: 'Fundamental (máx. {{max}})',
    fundamentalLabelUnbounded: 'Fundamental',
    maxFundamentalsHint: 'Solo puedes seleccionar hasta {{max}} Fundamental(es).',
    behaviorsLabel: 'Comportamientos',
    habitsLabel: 'Hábitos diarios',
    habitRequiredHint: 'Selecciona al menos un daily habit para poder enviar.',
    summaryLabel: 'Resumen',
    edit: 'Editar',
    messageLabel: 'Tu mensaje',
    messagePlaceholder: '¿Por qué reconoces a esta persona?',
    anonymous: 'Enviar de forma anónima',
    sendToBrillamos: 'Enviar también a Brillamos',
    charCount: '{{count}} caracteres',
    charsAvailableHint: 'Estás por alcanzar el límite. Te quedan {{remaining}} caracteres de {{max}}.',
    charsLimitReachedHint: 'Llegaste al límite de {{max}} caracteres. Resume alguna parte para seguir escribiendo.',
    charsLimitSentenceNote: 'La frase que armaste en el post-it también cuenta dentro del límite.',
    errMessageTooLong: 'Tu mensaje supera el máximo de {{max}} caracteres. Resume alguna parte y vuelve a enviarlo.',
    errRecipientRequired: 'Elige a la persona que quieres reconocer antes de enviar.',
    errFundamentalRequired: 'Elige al menos un Fundamental antes de enviar.',
    errSessionUnknown: 'No pudimos identificar tu sesión. Cierra la aplicación, vuelve a entrar e inténtalo otra vez.',
    send: 'Enviar',
    sending: 'Enviando…',
    sentTitle: '¡Reconocimiento enviado!',
    sentSubtitle: 'Visible para el equipo y el líder.',
    sendErrorGeneric: 'No se pudo enviar el reconocimiento. Inténtalo de nuevo.',
    legalHint: 'Debes aceptar los términos legales vigentes antes de reconocer.',
    sendingDisabledHint: 'El envío de reconocimientos está desactivado temporalmente.',
    scheduleRestrictedHint: 'El envío está fuera del horario habilitado para tu localidad en este momento.',
    weeklyLimitHint: 'Hay un tope de {{count}} reconocimientos por semana para tu localidad.',
    missingRecipientsHint: 'Selecciona al menos una persona a quien reconocer.',
    missingFundamentalHint: 'Selecciona al menos un Fundamental.',
    messageMinCharsHint: 'Escribe al menos {{count}} caracteres en tu mensaje.',
    missingBehaviorForHabitHint: 'Elige un comportamiento para ver los daily habits disponibles.',
    noHabitsAvailableHint: 'Este Fundamental no tiene daily habits configurados; elige otro.',
    groupTag: 'Equipo',
    delegateTitle: 'Modalidad de envío',
    modeSelfTab: 'A mi nombre',
    modeOnBehalfTab: 'En representación de otro',
    delegateLabel: 'A nombre de',
    delegateSubtitle: 'Puedes enviar reconocimientos en nombre de colaboradores de línea.',
    delegatePlaceholder: 'Buscar colaborador…',
    onBehalfActiveBanner: 'Estás reconociendo en representación de {{name}}.',
  },
  profile: {
    title: 'Mi perfil de reconocimiento',
    subtitle: 'Tu actividad de reconocimiento y tu racha.',
    received: 'Recibidos',
    sent: 'Enviados',
    streak: 'Racha',
    empty: 'Todavía no tienes actividad de reconocimiento.',
    weeksStreak: 'Semanas de racha',
    monthsStreak: 'Meses de racha',
    record: 'Récord',
    totalSent: 'Enviados',
  },
  catalog: {
    title: 'Fundamentales',
    empty: 'El catálogo de Fundamentales está vacío.',
  },
  notifications: {
    title: 'Notificaciones',
    close: 'Cerrar notificaciones',
    placeholder: 'La bandeja de notificaciones estará disponible próximamente.',
    unread: '{{count}} sin leer',
    markAllRead: 'Marcar todas como leídas',
    markRead: 'Marcar como leída',
    readState: 'Estado de lectura',
    inviteToRecognize: 'Invita a reconocer',
    markUnread: 'Marcar como no leída',
    loadMore: 'Ver notificaciones anteriores',
    recognitionUnavailable: 'Este reconocimiento ya no está disponible.',
    unsavedTitle: 'Tienes cambios sin guardar',
    unsavedDesc: 'Si sales ahora, perderás lo que estás escribiendo.',
    unsavedConfirm: 'Salir sin guardar',
    unsavedCancel: 'Seguir aquí',
    campaignInactive: 'La campaña de este reconocimiento ya finalizó, por eso no se puede abrir.',
    campaignUnavailable: 'Esta campaña ya finalizó, por eso no es posible abrirla.',
    unavailable: 'La bandeja no está disponible por ahora.',
    empty: 'No tienes notificaciones.',
  },
  // ── WP-12/WP-13 (D4) — Brillamos+Nominar, Librería, Perfil, Wrapped ──
  home: {
    sent: 'Enviados', received: 'Recibidos', recognizeCta: 'Reconocer ahora', recent: 'Reconocimientos Recientes',
    active: 'Campaña activa',
    ended: 'Campaña finalizada',
    daysLeft: '{{count}} días restantes',
    heroLogoAlt: 'Shine Together',
    nominateNow: 'Nominar ahora',
    // Paridad demo (D1/D2) — hero de /app/reconocer, calcado de HomePage.tsx del demo
    // (`home.title.line1` + `home.title.vive` + logo `fundamentals-v2.svg`).
    titleLine1: 'Nomina a quien',
    titleVive: 'vive los',
    subtitle: 'Reconoce a un compañero que inspira a otros al vivir nuestros Fundamentales.',
    cta: '✨ Reconocer a alguien',
    // Paridad demo — estados vacios de los dos muros de la home (HomePage.tsx : 501 / 535).
    emptySent: '¡Aún no has reconocido a nadie!',
    emptyReceived: '¡Sigue viviendo los Fundamentales y pronto te reconocerán!',
  },
  streak: {
    title: 'Tu racha de reconocimientos',
    subtitle: '¡Reconoce cada semana y sigue brillando!',
    subtitleMonthly: '¡Reconoce cada mes y sigue brillando!',
    weeks: 'sem',
    months: 'meses',
    month: 'mes',
    monthsMany: 'meses',
    record: 'Récord',
    total: 'Nominaciones',
    activeDays: '{{count}} días activos esta semana',
    currentLevel: 'NIVEL ACTUAL',
    atRisk: 'Tu racha está en riesgo esta semana',
    atRiskMonthly: 'Tu racha está en riesgo este mes',
    // FASE 7 (paridad demo, H-91) — familia .streak-* unificada.
    current: 'Racha actual',
    thisWeek: 'Esta semana',
    days: 'días',
    today: '¡Hoy!',
    nudgeDone: '¡Ya brillaste hoy! Sigue así 🌟',
    nudgeTodo: '¡Reconoce hoy y mantén tu racha! 🚀',
    // RF-036 — Progreso del período abierto. `sent`/`min` los sirve el backend ya calculados
    // (`enviosPeriodo`/`minimoPeriodo`): el cliente NO recalcula ni el tope anti-abuso ni el mínimo.
    periodProgress: '{{sent}} de {{min}} esta semana',
    periodProgressDone: '¡Meta de la semana cumplida! ({{sent}} de {{min}})',
    periodProgressMonthly: '{{sent}} de {{min}} este mes',
    periodProgressDoneMonthly: '¡Meta del mes cumplida! ({{sent}} de {{min}})',
    // RF-036 — La racha ya incluye el período abierto; el cierre solo lo confirma.
    provisionalNote: 'Incluye esta semana · se confirma al cierre',
    provisionalNoteMonthly: 'Incluye este mes · se confirma al cierre',
    badgeProvisional: 'AL CIERRE',
    badgeProvisionalTooltip: 'Ya cumpliste el mínimo de este periodo: la insignia ya se muestra, y se confirma oficialmente cuando el periodo cierre.',
    badgesTitle: 'Insignias',
    celebration: {
      title: '¡Insignia desbloqueada!',
      message: '¡Sigue así, tu constancia se nota!',
      cta: '¡Genial!',
    },
    badgeWeek: '{{count}} semana',
    badgeWeeks: '{{count}} semanas',
    badgeWeeksMany: '{{count}} semanas',
    badgeMonth: '{{count}} mes',
    badgeMonths: '{{count}} meses',
    badgeMonthsMany: '{{count}} meses',
    note: '* La racha se calcula por reconocimientos enviados',
    day: { mon: 'L', tue: 'M', wed: 'X', thu: 'J', fri: 'V', sat: 'S', sun: 'D' },
  },
  // 2026-08-10 — solo `crossOu` sigue viva (la usa NominarView). El resto pertenecía al "Feed de
  // actividad" de Brillamos Juntos (`BrillamosFeed`, borrado del árbol a petición del cliente).
  feed: {
    crossOu: 'Cross-OU',
  },
  docs: {
    allLanguages: "Todos los idiomas",
    title: 'Documentos de la Campaña',
    download: 'Descargar',
    loadError: 'No se pudo cargar el documento.',
    cat: {
      howto: 'Cómo Nominar',
      awards: 'Premios',
      legal: 'Bases Legales',
      privacy: 'Política de Privacidad',
      cookies: 'Política de Cookies',
      notice: 'Aviso Legal',
    },
  },
  library: {
    title: 'Los Fundamentales',
    subtitle: 'La base de cómo trabajamos, colaboramos y crecemos en Sigma.',
    watchVideo: 'Ver video',
    behaviorsCount: '{{count}} Actitudes y Comportamientos',
    dailyHabits: 'Hábitos Diarios',
    micrositeSpace: 'Espacio de micrositio cultural',
  },
  nominate: {
    back: 'Brillamos Juntos',
    thanksTo: 'Gracias a {{name}} por',
    demonstrating: 'demostrando {{fundamental}}',
    defaultMessage: 'Reconocimiento enviado',
    sentTitle: '¡Nominación enviada!',
    sentSubtitle: 'Gracias por hacer brillar a {{name}}.',
    redirecting: 'Volviendo a la campaña…',
    yourRecognition: 'Tu reconocimiento',
    thanksWord: 'Gracias a',
    slotWho: '¿quién?',
    forWord: 'por',
    slotWhat: '¿qué hizo?',
    demonstratingWord: 'demostrando',
    slotFund: '¿fundamental?',
    elements: '{{done}}/3 elementos',
    eyebrow: 'Crear Reconocimiento',
    title: 'Completa los tres campos',
    field1: 'Etiqueta a tu compañero/a',
    searchPlaceholder: 'Nombre del compañero/a…',
    noResults: 'No encontramos a nadie con ese nombre.',
    field2: '¿En qué Fundamental?',
    field3: '¿Qué hizo?',
    noActions: 'Este Fundamental no tiene comportamientos configurados.',
    pickFundFirst: 'Elige primero un Fundamental.',
    completeMessage: 'Completa tu mensaje',
    personalizeTitle: 'Personaliza tu mensaje',
    personalizeSub: 'Añade tu voz. El resto ya está listo.',
    messagePlaceholder: 'Describe el momento específico que observaste…',
    charCount: '{{count}} caracteres',
    idealRange: '30–80 ideal',
    nudgeText: 'Tu mensaje tendrá más impacto si agregas una línea propia.',
    addLine: 'Agregar línea',
    sendAnyway: 'Enviar así',
    send: 'Enviar Nominación',
  },
  wrapped: {
    readyTitle: 'Tu Recap está listo', readySubtitle: 'Revive los momentos que hicieron brillar tu {{year}}.', open: 'Ver mi Recap',
    // RF-130 — Los TÍTULOS de las diapositivas los captura el admin en Admin › Recap y llegan con la
    // edición vigente, así que aquí sólo quedan los rótulos del producto: etiquetas de respaldo,
    // estados y el aviso. Las 14 claves de títulos que vivían en este bloque se quedaron sin
    // consumidor al pasar el overlay a leer la configuración, y se retiraron (D-6 del plan RF-130).
    introHint: 'Un vistazo a tu año reconociendo.',
    topReceptor: 'A quien más reconociste',
    topEmisor: 'Tu fan #1',
    topFundamentalHint: 'El que más celebraste.',
    bottomFundamentalHint: 'El que menos celebraste. Tu reto para este año.',
    crossOuValue: '{{count}} reconocimientos cross-OU',
    messageFrom: 'De {{name}}',
    winnerYear: 'Año {{anio}}',
    winnerPosition: 'Lugar {{position}}',
    sinceMonth: 'Tu resumen cubre desde {{month}}.',
    streakValue: '{{count}} semanas',
    streakValueOne: '{{count}} semana',
    streakValueMany: '{{count}} semanas',
    streakValueMonth: '{{count}} meses',
    streakValueMonthOne: '{{count}} mes',
    streakValueMonthMany: '{{count}} meses',
    unavailable: 'Tu Wrapped aún no está disponible.',
    // RF-130 corrección F1 (H-06) — el backend manda una CLAVE ESTABLE (`GetRecognitionWrappedQueryHandler.cs`),
    // no texto. `WrappedModal.tsx` la resuelve contra estas tres, con lista blanca: nunca `t(claveCruda)`.
    generosityTag: {
      generoso: 'Generoso',
      muyGeneroso: 'Muy generoso',
      superGeneroso: 'Súper generoso',
    },
  },
  prof: {
    myFolders: 'Mis reconocimientos recibidos filtrados por fundamental',
    viewingTitle: 'Perfil de {{name}}',
    backToMine: 'Mi perfil',
    myTeam: 'Equipo',
    searchColleague: 'Buscar un compañero/a…',
    campaignBannerSub: 'La campaña está activa — entra a Brillamos Juntos',
    ctaRecognize: 'Reconocer a alguien',
    myWrapped: 'Mi Wrapped {{year}}',
    brillamosFolder: 'Brillamos Juntos',
    emptySent: 'Aún no has enviado reconocimientos.',
    emptyBrillamos: 'Aún no hay reconocimientos de Brillamos aquí.',
    folderEmpty: 'Aún no hay reconocimientos en esta carpeta.',
    recognizeName: 'Reconocer a {{name}}',
    // FASE 6 (paridad demo, H-75/H-77/H-78) — perfil `.rp2-*`.
    thisWeek: 'Esta semana',
    weekdayInitials: 'L,M,M,J,V,S,D',
    badges: 'Insignias · Shine Together',
    recap: 'Wrapped {{year}}',
    sigmaMsg: '"Gracias por vivir la cultura de Sigma"',
    sigmaFrom: 'Sigma · {{year}}',
    sigmaNote: 'Sin reconocimientos recibidos en {{year}}. Este reconocimiento es un recordatorio de tu valor para el equipo.',
    sigmaNoteSent: 'Sin reconocimientos enviados en {{year}}. Este reconocimiento es un recordatorio de tu valor para el equipo.',
  },
  time: {
    moment: 'Hace un momento',
    hours: 'Hace {{n}}h',
    yesterday: 'Ayer',
    days: 'Hace {{n}} días',
  },
  // ── WP-11 REQ-104 — Post-it interactivo / Word Builder ──
  builder: {
    modeLabel: 'Modo de reconocimiento',
    modeClassic: 'Clásico',
    modeInteractive: 'Interactivo',
    previewLabel: 'Vista previa del reconocimiento',
    thanksWord: 'Reconozco a',
    forWord: 'por',
    demonstratingWord: 'demostrando',
    slotWho: '¿a quién?',
    slotWhat: '¿qué hizo?',
    slotFund: '¿fundamental?',
    stepOf: 'Paso {{step}} de {{total}}',
    step1Title: '¿A quién reconoces?',
    step3Title: '¿Qué comportamiento o hábito?',
    step4Title: 'Agrega tu mensaje',
    complementPlaceholder: 'Describe el momento específico que observaste…',
    noActions: 'Este Fundamental no tiene comportamientos ni hábitos configurados.',
    back: 'Atrás',
    next: 'Siguiente',
  },
  ri: {
    bankLabel: 'Banco',
    bankTitle: 'Elige tus palabras',
    bankHint: 'Toca una palabra aquí abajo para completar tu post-it 👇',
    forWhom: 'Para quién es',
    searchPlaceholder: 'Nombre del compañero/a…',
    catAccion: 'Fundamentales',
    catComportamiento: 'Comportamientos',
    catHabito: 'Hábitos',
    catImpacto: 'Impacto',
    msgLabel: 'Tu mensaje',
    msgTitle: 'Construye tu reconocimiento',
    words: 'elementos',
    clear: 'Limpiar',
    clickToRemove: 'Click para quitar',
    clickHint: 'Haz click en una palabra del banco',
    pickFundFirst: '👆 Elige un fundamental para ver sus comportamientos',
    pickBehaviorFirst: '👆 Elige un comportamiento para ver sus hábitos',
    noHabitsForFund: '👆 Este Fundamental no tiene hábitos configurados',
    howLabel: '¿Cómo funciona?',
    howTitle: 'Tres pasos sencillos',
    step1: '<strong>Pasa el mouse</strong> sobre una palabra y el slot de destino se iluminará.',
    step2: '<strong>Haz click</strong> en la palabra para colocarla en el mensaje.',
    step3: '<strong>Click en el slot</strong> del post-it para quitar una palabra puesta.',
    quote: 'Reconocer es nombrar lo invisible. Cuando le decimos a alguien lo que vemos en él, tejemos comunidad.',
    cta: 'Completa tu mensaje',
    ctaDone: 'Completa tu mensaje →',
    popupTitle: 'Agrega el toque personal',
    popupChars: '30-80 caracteres ideal',
    nudgeMsg: 'Tu mensaje tendrá más impacto si agregas una línea propia 💛',
    nudgeAdd: 'Agregar línea',
    nudgeSkip: 'Enviar así',
    sent: '¡Reconocimiento enviado!',
    sentIntro: 'Gracias a mi',
    continueBtn: 'Continuar →',
    seeRecognition: 'Ver mi reconocimiento →',
    clearReset: 'Limpiar y empezar de nuevo',
    wStep: 'Paso {{step}} de {{total}}',
    wQPersona: '¿A quién reconoces?',
    wQFund: '¿Qué fundamental vivió?',
    wQBehavior: '¿Qué comportamiento mostró?',
    wQHabit: '¿Cuál fue el hábito?',
    wQImpact: '¿Cuál fue su impacto?',
    templateThanks: 'Reconozco a',
    templateForLiving: 'por vivir',
    templateWith: 'con',
    templateShowing: ', demostrando que',
    templateThat: '. Eso',
    slotPersona: 'persona',
    slotAccion: 'fundamental',
    slotComportamiento: 'comportamiento',
    slotHabito: 'hábito',
    slotImpacto: 'impacto',
    impact1: 'nos inspira',
    impact2: 'nos hace crecer',
    impact3: 'nos alinea',
    impact4: 'mueve al equipo',
    tooltipFundamental: 'Un Fundamental es el valor que la persona vivió.',
    tooltipComportamiento: 'El comportamiento concreto que demostró ese valor.',
    tooltipHabito: 'El hábito diario donde se nota ese comportamiento.',
    tooltipImpacto: 'El efecto que tuvo en el equipo.',
    guideStep1Title: 'Elige tus palabras',
    guideStep1Text: 'Aquí eliges el Fundamental, comportamiento, hábito e impacto que quieres reconocer.',
    guideStep2Title: 'Se arma tu post-it',
    guideStep2Text: 'Cada palabra que eliges llena un espacio en la frase de tu reconocimiento.',
    guideStep3Title: 'Agrega tu toque personal',
    guideStep3Text: 'Este mensaje es opcional, pero hace tu reconocimiento más cercano.',
    guideStep4Title: 'Envía tu reconocimiento',
    guideStep4Text: 'Cuando esté completo, este botón se activa y puedes enviarlo.',
    guideReopen: 'Ver la guía de nuevo',
    guideNext: 'Siguiente',
    guideSkip: 'Saltar',
    guideDone: 'Entendido',
    progressLabel: '{{value}} de {{total}} pasos completados',
  },
  // ── WP-11 REQ-106 — Carga masiva CSV ──
  bulk: {
    or: 'o',
    open: 'Carga masiva',
    title: 'Carga masiva de reconocimientos',
    subtitle: 'Sube un CSV con varios reconocimientos a la vez, revisa y corrige antes de confirmar.',
    stepInstructions: 'Instrucciones',
    stepUpload: 'Subir archivo',
    stepReview: 'Revisar',
    stepConfirm: 'Confirmar',
    stepOf: 'Paso {{step}} de {{total}}',
    next: 'Siguiente',
    back: 'Atrás',
    instructionsIntro: 'Descarga la plantilla, complétala con un colaborador por fila y súbela para validar y cargar en lote.',
    matchByIdentity: 'Busca a la persona por su correo electrónico o por su número de nómina — con uno de los dos basta. ¿No conoces su correo? La nómina funciona igual de bien.',
    onePersonPerRowWarning: 'Importante: cada línea del archivo es UNA sola persona. No pongas varios correos o números de nómina en la misma celda — si necesitas reconocer a varias personas, agrega una línea por cada una.',
    // colRequired/colOptional: compartidas con adminBulkUsers/StepInstructions.tsx (padrón Europa/EE. UU.)
    // — este wizard ya no las usa (sus columnas fijas no llevan etiqueta obligatoria/opcional). No
    // eliminar en una limpieza de este wizard sin revisar antes ese otro consumidor.
    colRequired: 'Obligatoria',
    colOptional: 'Opcional',
    colNameNombre: 'Nombre',
    colNameCorreoNomina: 'Correo o Nómina',
    colNameFundamental: 'Fundamental',
    colReceptorEmailDesc: 'Correo de quien recibe el reconocimiento.',
    colMensajeDesc: 'Mensaje del reconocimiento. Puede ser obligatorio según tu unidad organizacional.',
    colEmisorEmailDesc: 'Correo de quien envía. Vacío = tú.',
    colReceptorNominaDesc: 'Número de nómina de quien recibe (AD, SuccessFactors o padrón Europa). Alternativa al correo — no lo reemplaza, sirve cuando la persona aún no tiene correo o no se ha registrado.',
    colEmisorNominaDesc: 'Número de nómina de quien envía. Vacío = tú.',
    markColumnsTitle: 'Y una columna por cada Fundamental, Comportamiento y Daily Habit',
    markColumnsIntro: 'Después de esas columnas fijas vas a ver una columna por cada uno — marca con una X (o cualquier señal, como "sí") la que corresponda. No necesitas escribir ningún código.',
    markFundamentalHint: 'Marca uno o más Fundamentales por fila — hasta el tope que permita tu unidad organizacional.',
    markBehaviorHint: 'El Comportamiento es opcional — puedes marcar varios.',
    markHabitHint: 'Los Daily Habits son opcionales — puedes marcar varios.',
    markColumnsOutro: 'La columna Mensaje va al final del archivo, después de todas las columnas de marca.',
    downloadTemplate: 'Descargar plantilla',
    templateError: 'No se pudo descargar la plantilla.',
    catalogError: 'No se pudo cargar el catálogo de Fundamentales. Vuelve a intentarlo — sin el catálogo, el archivo no se puede validar.',
    upload: 'Subir CSV',
    dragDropHint: 'Arrastra tu archivo CSV aquí o haz clic para seleccionarlo.',
    invalidFileType: 'Solo se aceptan archivos CSV.',
    emptyFile: 'El archivo no tiene filas de datos.',
    parseError: 'No se pudo leer el archivo CSV.',
    uploadError: 'No se pudo procesar la carga masiva.',
    validRows: '{{count}} filas válidas',
    invalidRows: '{{count}} con errores',
    reviewHint: 'Corrige las filas marcadas en rojo directamente en la tabla; cada cambio se vuelve a validar.',
    colLine: '#',
    colReceptor: 'Receptor',
    colFundamental: 'Fundamental',
    colMensaje: 'Mensaje',
    colReceptorNomina: 'Nómina',
    colBehavior: 'Comportamiento',
    colHabits: 'Daily Habits',
    colStatus: 'Estado',
    ok: 'Válida',
    expandRow: 'Ver detalle de la fila {{line}}',
    collapseRow: 'Ocultar detalle de la fila {{line}}',
    habitsCount_one: '{{count}} Daily Habit',
    habitsCount_other: '{{count}} Daily Habits',
    revalidating: 'Revalidando…',
    downloadErrors: 'Descargar errores (CSV)',
    confirmSummary: 'Se crearán {{count}} reconocimientos. Las filas con error se omiten.',
    confirm: 'Cargar {{count}} válidas',
    committed: 'Se crearon {{created}} reconocimientos. {{skipped}} filas se omitieron.',
    duplicatesSkipped_one: '1 reconocimiento no se envió: ya se había enviado antes con el mismo mensaje.',
    duplicatesSkipped_other: '{{count}} reconocimientos no se enviaron: ya se habían enviado antes con el mismo mensaje.',
    notFoundTitle: 'Correos no encontrados en el directorio:',
    errors: {
      receptorRequired: 'Falta el correo del receptor.',
      receptorNotFound: 'Este correo no existe en el directorio.',
      multiplePeopleNotSupported: 'Esta columna debe traer una sola persona (un correo o una nómina). Si quieres reconocer a varias personas, agrega una línea por cada una.',
      fundamentalInvalid: 'El Fundamental es obligatorio, o el mensaje no cumple lo requerido en tu unidad organizacional.',
      selfRecognition: 'No puedes reconocerte a ti mismo.',
      blockedWord: 'El mensaje contiene una palabra no permitida.',
      weeklyCapExceeded: 'El emisor alcanzó su tope semanal de reconocimientos.',
      duplicateInFile: 'Esta fila se repite en el archivo.',
      behaviorInvalid: 'El Comportamiento no es válido para el Fundamental de esta fila.',
      habitInvalid: 'Alguno de los Daily Habits no es válido para el Fundamental de esta fila.',
      campaignClosed: 'La campaña no está activa.',
      notAllowedForCampaign: 'Esta fila no está permitida para la campaña de este lote.',
      maxFundamentalsExceeded: 'No es posible seleccionar más Fundamentales en este reconocimiento: el límite está definido por la configuración de la unidad organizacional del emisor.',
      generic: 'No se pudo validar esta fila.',
    },
  },
  // ── WP-11 REQ-107 — Acciones de post-it ──
  actions: {
    // RF-086 / RN-M06 — el catálogo de motivos (`reportReasons`) se eliminó: el motivo es texto libre.
    reportCharsLeft: 'Quedan {{n}} caracteres',
    edit: 'Editar',
    report: 'Reportar',
    delete: 'Eliminar',
    saveEdit: 'Guardar',
    editError: 'No se pudo editar el reconocimiento.',
    editMinChars: 'El mensaje debe tener al menos {{min}} caracteres ({{count}}/{{min}}).',
    reportReason: 'Motivo del reporte',
    reportPlaceholder: 'Describe brevemente el problema…',
    reportError: 'No se pudo enviar el reporte.',
    reportSent: 'Reporte enviado. Nuestro equipo lo revisará.',
    sendReport: 'Enviar reporte',
    deleteConfirm: '¿Seguro que quieres eliminar este reconocimiento? Esta acción no se puede deshacer.',
    deleteError: 'No se pudo eliminar el reconocimiento.',
    confirmDelete: 'Sí, eliminar',
  },
  // ── WP-15 — Admin (REQ-126/127/128) ──
  admin: {
    // PLAN WP-U8-T5 — estas claves no existian en ningun locale.
    bulkUsers: {
      title: 'Carga masiva del padrón (Europa y EE. UU.)',
      descLong: 'Alta y actualización del padrón de Europa y EE. UU. por CSV de 24 columnas, más la región del archivo (Europa o USA), que se elige al subirlo. Es incremental: quien no venga en el archivo no se modifica, y las bajas se marcan con la columna EMPLOYEE DELETED. El resto de las regiones las sincroniza SuccessFactors automáticamente.',
      importHint: 'Descarga la plantilla, complétala y súbela. Al subirla se muestra primero una vista previa que no escribe nada. Fechas en formato MM/dd/yyyy.',
      openWizard: 'Abrir carga masiva',
      wizardSubtitle: 'Sube el CSV del padrón, revisa el resultado y confirma — nada se escribe hasta el último paso.',
      confirm: 'Confirmar la carga',
      downloadErrors: 'Descargar errores (CSV)',
      received: 'Filas',
      created: 'Creados',
      updated: 'Actualizados',
      deactivated: 'Dados de baja',
      skipped: 'Omitidos',
      disabled: 'La carga masiva de Europa y EE. UU. está deshabilitada en la configuración de fuentes.',
      previewNotice: 'Vista previa: todavía no se ha escrito nada. Estos son los conteos que tendrá la carga real.',
      allOk: 'Todas las filas se procesaron sin errores.',
      importError: 'No se pudo procesar el archivo.',
      importErrorTimeout: 'El servidor tardó demasiado en responder. Es posible que la carga se haya completado igual del lado del servidor — verifica el padrón antes de reintentar. Referencia: {{correlationId}}',
      ignoredColumnsNotice: 'Estas columnas de tu archivo no se reconocen y se ignorarán: {{columns}}',
      confirmRecap: 'Se procesarán {{total}} filas: {{created}} altas, {{updated}} actualizaciones, {{deactivated}} bajas.',
      committed: 'Carga completada: {{created}} altas, {{updated}} actualizaciones, {{deactivated}} bajas, {{skipped}} omitidas.',
      paginationPage: 'Página {{page}} de {{total}}',
      errorColumn: 'Columna',
      errorDetail: 'Detalle de errores / omisiones',
      ouLabel: 'Región del archivo',
      ouPlaceholder: 'Selecciona una región',
      ouEuropa: 'Europa',
      ouUsa: 'Estados Unidos (USA)',
      ouCentral: 'Central',
      ouHint: 'Aplica a todas las filas del archivo. Ya no se escribe por fila en el CSV, para evitar errores de tipeo o de idioma.',
      ouRequired: 'Selecciona la región antes de subir el archivo.',
      col: {
        employeeDeleted: '1 da de baja a la persona; 0 o vacío la deja activa.',
        localId: 'Nómina del colaborador. Es la llave: sin ella la fila no se puede procesar.',
        firstName: 'Nombre de pila.',
        lastName: 'Primer apellido.',
        secondLastName: 'Segundo apellido (opcional).',
        completeName: 'Nombre completo tal como debe mostrarse. Si viene vacío, se arma con los tres campos anteriores.',
        email: 'Correo del colaborador. Puede ir vacío: la ficha queda en el padrón hasta que la persona se registre.',
        bu: 'Unidad de negocio.',
        siteId: 'Identificador del sitio/planta.',
        site: 'Nombre del sitio/planta.',
        orgDirectionId: 'Identificador de la Dirección Organizacional.',
        orgDirection: 'Nombre de la Dirección Organizacional.',
        funcDirectionId: 'Identificador de la Dirección Funcional.',
        funcDirection: 'Nombre de la Dirección Funcional.',
        departmentId: 'Identificador del Departamento.',
        department: 'Nombre del Departamento.',
        jobPosition: 'Puesto del colaborador.',
        manager: 'Nombre del jefe directo (solo informativo).',
        managerId: 'Nómina del jefe directo. Se usa para enlazar la jerarquía; el jefe debe existir en el padrón.',
        managerEmail: 'Correo del jefe directo (solo informativo).',
        hireDate: 'Fecha de ingreso, formato MM/dd/aaaa.',
        birthDate: 'Fecha de nacimiento, formato MM/dd/aaaa.',
        notification: "YES o NO: si la persona recibe notificaciones. Vacío se interpreta como 'no definido', no como NO.",
        country: 'País de la persona. Opcional, pero sin él la persona queda fuera del alcance de los administradores de país.',
      },
    },
    title: 'Administración',
    subtitle: 'Configura el Programa de Reconocimiento.',
    denied: 'No tienes permisos para acceder a esta sección.',
    save: 'Guardar',
    saving: 'Guardando…',
    saved: 'Cambios guardados',
    saveError: 'No se pudieron guardar los cambios.',
    rowsPerPage: 'Filas por página',
    fundPanelTitle: 'Admin Fundamentales — Reconocimiento',
    fundPanelSubtitle: 'Cada módulo es independiente. Activa o desactiva según las necesidades de tu organización.',
    pager: {
      showing: 'Mostrando {{range}} de {{total}}',
      perPage: '{{size}} por pág.',
      all: 'Todas',
      prev: 'Página anterior',
      next: 'Página siguiente',
      pageSize: 'Resultados por página',
    },
    nav: {
      roles: 'Configurar roles y permisos',
      points: 'Puntos',
      moderation: 'Moderación',
      winners: 'Ganadores',
      campaigns: 'Campañas',
      reports: 'Reportería',
      team: 'Equipo',
      dashboard: 'Tablero',
      management: 'Gestión',
      notifications: 'Notificaciones',
      views: 'Vistas',
      docs: 'Documentación',
      recap: 'Recap',
    },
    roles: {
      title: 'Configurar roles y permisos',
      desc: 'Gestiona administradores, su alcance por OU/país y su matriz de permisos.',
      searchEmail: 'Buscar por correo…',
      empty: 'No hay administradores para mostrar.',
      colAdmin: 'Administrador',
      colRole: 'Rol',
      colScope: 'Alcance',
      colStatus: 'Estado',
      allScopes: 'Todas',
      active: 'Activo',
      inactive: 'Inactivo',
      edit: 'Editar',
      remove: 'Quitar',
      removeConfirmTitle: 'Quitar administrador de Brillamos',
      removeConfirmMsg: '¿Quitar a "{{name}}" como administrador de Brillamos? Conservará su cuenta como colaborador estándar.',
      removeConfirm: 'Sí, quitar',
      removeError: 'No se pudo quitar el rol de administrador. Intenta de nuevo.',
      status: 'Estado',
      permMatrix: 'Matriz de permisos',
      readOnlyConflict: '«Solo lectura» no puede convivir con permisos de escritura (RN-R03). Hoy están marcados: {{permisos}}. Al tocar cualquier casilla se resolverá; si guardas así, el servidor lo rechazará.',
      addAdmin: 'Agregar administrador',
      addTitle: 'Agregar administrador',
      editTitle: 'Editar administrador — {{name}}',
      searchPersonLabel: 'Buscar colaborador',
      searchPersonPlaceholder: 'Nombre o correo del colaborador…',
      alreadyAdminNote: 'Esta persona ya es administrador de Brillamos — edita sus datos abajo.',
      cannotEditGlobal: 'Esta persona ya tiene el rol de Admin General. Ese rol no se gestiona desde aquí.',
      selectRolePlaceholder: 'Selecciona un rol…',
      selectRoleFirst: 'Elige un rol antes de guardar.',
      saveForbidden: 'No tienes permiso para hacer este cambio.',
      role: {
        AdminGlobal: 'Admin General',
        AdminBrillamos: 'Admin Reconocimiento',
        AdminOUBrillamos: 'Admin OU Reconocimiento',
      },
    },
    perm: {
      manageUsers: 'Gestionar usuarios',
      manageRecognitions: 'Gestionar reconocimientos',
      manageNotifications: 'Gestionar notificaciones',
      manageDocuments: 'Gestionar documentos',
      manageWinners: 'Gestionar ganadores',
      viewAnalytics: 'Ver analytics',
      viewReports: 'Ver reportería',
      exportData: 'Exportar datos',
      configureViews: 'Configurar vistas',
      bulkCsv: 'Envío masivo (CSV)',
      moderateContent: 'Moderar contenido',
      manageCampaigns: 'Gestionar campañas',
      createCampaigns: 'Crear y gestionar campañas',
      readOnly: 'Solo lectura',
      approveNominations: 'Confirmar Ganadores',
      managePoints: 'Gestión',
      manageRoles: 'Configurar roles y permisos',
      manageBlockedWords: 'Gestionar palabras bloqueadas',
      managePointsConfig: 'Puntos',
      manageRecap: 'Editar Recap anual',
      delegateRecognition: 'Reconocer a nombre de otro',
      accessCatalogFundamentals: 'Catálogo de Fundamentales',
      accessCatalogOus: 'Catálogo de OUs',
    },
    points: {
      title: 'Puntos',
      desc: 'Configura los puntos por criterio (0-9) en espejo Staff/Frontline. Los puntos nunca son visibles al empleado.',
      empty: 'No hay criterios de puntos configurados.',
      seg: { staff: 'Staff', frontline: 'Frontline' },
      segmentActive: 'Activo',
      segmentActiveHint: 'Si está apagado, esta tabla (Staff o Frontline) no otorga puntos aunque tenga criterios configurados.',
      lockedCampaign: 'La configuración no es editable con una campaña iniciada.',
      campaignActiveWarning: 'No se puede editar la configuración de puntos mientras haya una campaña activa en esta unidad organizativa.',
      colCategory: 'Categoría',
      colCriterion: 'Criterio',
      colPoints: 'Puntos',
      colActive: 'Activo',
      criterionActiveHint: 'Si está apagado, este criterio no otorga puntos aunque se cumpla.',
      colAccumulated: 'Total acumulado',
      accumulatedFooter: 'Nominaciones evaluadas',
      resetAccumulated: 'Restablecer a 0',
      resetAccumulatedConfirmTitle: 'Restablecer el acumulado',
      resetAccumulatedConfirmMessage: 'Se reiniciará a 0 el contador de "Total acumulado" de esta OU y segmento. El histórico de reconocimientos NO se borra; solo deja de contarse desde ahora. Esta acción no se puede deshacer.',
      resetAccumulatedSuccess: 'El acumulado se restableció a 0.',
      resetAccumulatedError: 'No se pudo restablecer el acumulado.',
      accumulatedError: 'No se pudo cargar el conteo de nominaciones.',
      accumulatedDisabledHint: 'Con los puntos desactivados el motor no evalúa, así que el acumulado se mantiene en cero aunque haya reconocimientos.',
      globalToggle: 'Aplican puntos (global)',
      globalToggleHint: 'Enciende o apaga el sistema de puntos para TODAS las unidades organizativas, sin importar lo que tenga configurado cada una individualmente.',
      visibleToEmployees: 'Visible para empleados',
      visibleToEmployeesHint: 'Muestra en el post-it los puntos de cada reconocimiento de esta OU. Nunca el acumulado de una persona.',
      visibleUnknown: 'No se pudo leer el estado del interruptor. No se cambia nada hasta saberlo.',
      visibleGdprBlocked: 'Esta OU está sujeta a GDPR: los puntos no se muestran aunque el interruptor esté encendido.',
      globalOffHint: 'El interruptor global está apagado: ninguna OU acredita puntos, aunque su tabla esté activa.',
      ouPicker: 'Unidad organizativa',
      ouPickPlaceholder: 'Selecciona una unidad…',
      pickOuFirst: 'Selecciona una unidad organizativa para ver y editar su configuración de puntos.',
      accumulatedNoKey: 'Este criterio no tiene clave canónica, así que no se puede casar con el conteo.',
      globalOverriddenHint: 'Esta unidad tiene una excepción propia, así que aquí el interruptor está {{estado}} sin importar el valor global.',
      globalOn: 'encendido',
      globalOff: 'apagado',

      globalUnknown: 'No se pudo leer el interruptor global; su estado real se desconoce.',
      noOuInProfile: 'Tu ficha no tiene una unidad organizativa asignada, así que no hay configuración de puntos que mostrar. Pídelo al administrador global.',
      exportReport: 'Descargar reporte de puntos',
      exporting: 'Descargando…',
      exportError: 'No se pudo generar el reporte de puntos. Intenta de nuevo.',
      exportEmpty: 'No hay filas de puntos que exportar en este alcance.',
      exportTruncated: 'El reporte se truncó en {{tope}} filas; acota el alcance para exportar todo.',
      exportNamesUnresolved: 'No se pudieron resolver algunos nombres; esas filas salen con su identificador.',
      exportColPerson: 'Persona',
      exportColOu: 'Unidad organizativa',
      exportColPoints: 'Puntos'
    },
    placeholder: {
      soon: 'Esta sección estará disponible próximamente.',
      tracked: 'Seguimiento: {{req}}',
    },
    recognitions: {
      title: 'Reconocimientos',
      descLong: 'Gestiona el catálogo de Fundamentales/Hábitos: alta, edición, activar/desactivar, ligar a campaña y micrositio.',
      tabActive: 'Fundamentales',
      tabTrash: 'Papelera',
      tabHabits: 'Daily Habits',
      newHabit: 'Nuevo Daily Habit',
      habitSearchPlaceholder: 'Buscar hábito…',
      habitsEmpty: 'No hay Daily Habits en el catálogo.',
      colColor: 'Color',
      colNameEs: 'Nombre (ES)',
      colNameEn: 'Nombre (EN)',
      colParent: 'Fundamental padre',
      colOuVisibility: 'Visibilidad por OU',
      ouInherited: 'Hereda del fundamental',
      habitStatusAll: 'Todos',
      habitStatusActive: 'Activos',
      habitStatusInactive: 'Inactivos',
      deleteHabitConfirm: '¿Eliminar este Daily Habit del catálogo?',
      newHabitTitle: 'Nuevo Daily Habit',
      editHabitTitle: 'Editar Daily Habit',
      new: 'Nuevo Fundamental',
      searchPlaceholder: 'Buscar por código o nombre…',
      empty: 'El catálogo está vacío.',
      colCode: 'Código',
      colName: 'Nombre',
      colHabits: 'Hábitos',
      colBrillamos: 'Brillamos',
      colMicrosite: 'Micrositio',
      colStatus: 'Estado',
      inBrillamos: 'En Brillamos',
      notInBrillamos: 'Fuera',
      openMicrosite: 'Abrir',
      edit: 'Editar',
      deleteConfirm: '¿Enviar este Fundamental a la papelera?',
      trashEmpty: 'La papelera está vacía.',
      newTitle: 'Nuevo Fundamental',
      editTitle: 'Editar {{code}}',
      needAllLangs: 'Completa el nombre en los 7 idiomas.',
      fieldCode: 'Código',
      fieldOrder: 'Orden',
      fieldName: 'Nombre',
      fieldShortName: 'Nombre corto',
      fieldColor: 'Color',
      fieldMicrosite: 'URL de micrositio',
      fieldCampaignScope: 'Campaña ligada',
      campaignScopeHint: 'Id de campaña (vacío = catálogo global)',
      fieldBrillamos: 'Participa en Brillamos Juntos',
      legacyCatalogWarning: 'Este catálogo es temporal: los cambios aquí no se reflejan todavía en lo que ven las personas al reconocer (P2-010).',
    },
    moderation: {
      desc: 'Palabras bloqueadas y bandeja de reportes.',
      title: 'Moderación',
      descLong: 'Bandeja de reportes con canalización, catálogo de palabras bloqueadas y toggles de moderación.',
      contentTitle: 'Moderación de Contenido',
      wordsTitle: 'Palabras Bloqueadas',
      wordsDesc: 'Se detectan y bloquean automáticamente al enviar un reconocimiento.',
      wordsCounted: 'palabras bloqueadas',
      manageWords: 'Gestionar',
      wordsManagerDesc: 'Agrega, edita o elimina palabras por idioma. Compatible con 100+ palabras.',
      newWord: 'Nueva palabra',
      region: 'País/Región',
      regionGlobal: 'Global (todas)',
      regionHint: 'El mismo idioma puede tener palabras distintas por país o región.',
      allRegions: 'Todas las regiones',
      searchWord: 'Buscar…',
      editWord: 'Editar palabra',
      word: 'Palabra',
      wordPlaceholder: 'Ej: inapropiado…',
      language: 'Idioma',
      addWord: 'Agregar',
      wordsEmpty: 'No se encontraron palabras.',
      langOther: 'Otros',
      // RF-082 — tabla país→idiomas que gobierna qué catálogo aplica a cada emisor.
      countryLanguagesTitle: 'Países e idiomas',
      countryLanguagesDesc: 'Define qué idiomas se hablan en cada país. Un país multilingüe (Bélgica: nl y fr) aplica las palabras de todos sus idiomas sin capturarlas dos veces. Países en ISO-3166 (MX, ES, BE) e idiomas entre los 7 de la plataforma (es, en, pt, fr, de, nl, ro). Para acotar una palabra a un país concreto usa su campo País/Región.',
      countryLanguagesEmpty: 'La tabla de países e idiomas está vacía.',
      regionsTitle: 'Regiones',
      regionMembers: 'Países que la componen',
      countryLanguagesInvalid: 'Revisa estos códigos antes de guardar: {{codes}}. El país va en ISO de 2 letras (MX) y el idioma tiene que ser uno de los 7 de la plataforma (es, en, pt, fr, de, nl, ro), sin variante de país.',
      countryLanguagesUnreadable: 'No se pudo leer la tabla, así que no se puede guardar: al guardar se reemplaza entera y se perdería lo que no se ve.',
      country: 'País',
      languages: 'Idiomas',
      languagesPlaceholder: 'nl, fr',
      addCountry: 'Agregar país',
      countryPlaceholder: 'MX',
      autoTitle: 'Configuración de Auto-Moderación',
      aiAutoBlock: 'Bloqueo automático por IA',
      aiAutoBlockHint: 'Cuando está activo, cada mensaje de reconocimiento se revisa con IA (Azure AI Content Safety) al enviarse y se bloquea si es ofensivo.',
      helpAria: 'Ayuda',
      aiHelp: 'Revisa cada mensaje con IA (Azure AI Content Safety) al enviarse y detecta toxicidad en contexto (odio, amenazas, acoso). Es adicional al catálogo de palabras bloqueadas: ambos pueden estar activos a la vez. Requiere que "Moderación activa (global)" esté encendida; con el interruptor global apagado, esta capa no aplica.',
      globalHelp: 'Interruptor maestro de la moderación. Si está apagado, NADA se modera: ni el bloqueo por IA, ni el catálogo de palabras bloqueadas, ni se aceptan reportes. Enciéndelo para que las demás capas funcionen.',
      wordsHelp: 'Bloquea palabras exactas al enviar, sin importar el contexto. Complementa al bloqueo por IA (que detecta toxicidad en contexto). Ambas capas requieren que "Moderación activa (global)" esté encendida.',
      hideThreshold: 'Umbral de reportes para ocultar',
      notifyReporter: 'Notificar al reportador',
      aiPendingNote: 'Con el bloqueo automático por IA activo, los mensajes de reconocimiento se validan con Azure AI Content Safety al enviarse y se rechazan si incumplen las normas de convivencia. Funciona en conjunto con el catálogo de palabras bloqueadas.',
      hideThresholdHint: 'Cuántos reportes hacen falta para ocultar un reconocimiento automáticamente. El valor 1 es la regla vigente: se oculta al primer reporte.',
      notifyReporterHint: 'Guarda la preferencia y la envía con el evento de moderación. El correo al reportador lo enviará NotificationService cuando esa notificación exista.',
      advanced: 'Configuración avanzada',
      globalEnabled: 'Moderación activa (global)',
      reportEnabledGlobal: 'Reportar habilitado por defecto',
      dailyReportLimit: 'Límite diario de reportes',
      // RF-084 — overrides de "permitir reportes" por nodo, con cascadeo Site → BU → OU → global.
      overridesTitle: 'Reportar por unidad (cascadeo)',
      overridesDesc: 'Excepciones al valor global. Se aplica la del nodo más específico: Site, luego BU, luego OU y sus unidades superiores. Una unidad sin excepción hereda la de su unidad madre.',
      overridesNode: 'Unidad, BU o Site',
      overridesNodePlaceholder: 'Elige una OU o escribe un id de BU/Site',
      overridesAllow: 'Permitido',
      overridesBlock: 'Bloqueado',
      overridesEmpty: 'Sin excepciones: todas las unidades usan el valor global.',
      overridesDuplicate: 'Ya existe una excepción para «{{node}}». Los identificadores no distinguen mayúsculas de minúsculas: edita o elimina la existente.',
      inboxTitle: 'Bandeja de Reportes',
      inboxDesc: 'Reportes de usuarios. Al ocultar, el reconocimiento desaparece del muro de quien lo recibió y de los reconocimientos enviados de quien lo emitió; también se remueve del medallero y cancela puntos.',
      searchName: 'Buscar por nombre…',
      filterAll: 'Todos',
      filterOu: 'OU: Todas',
      filterBu: 'BU: Todas',
      filterSite: 'Site: Todos',
      filterFrom: 'Desde',
      filterTo: 'Hasta',
      filterType: 'Tipo: Todas',
      type: { fundamentales: 'Fundamentales', brillamos: 'Brillamos Juntos', diario: 'Reco Diario' },
      uiStatus: { pendiente: 'Pendiente', restaurado: 'Restaurado', eliminado: 'Eliminado' },
      uiStatusPlural: { pendiente: 'Pendientes', restaurado: 'Restaurados', eliminado: 'Eliminados' },
      status: { Publicado: 'Publicado', Pendiente: 'Pendiente', Resuelto: 'Resuelto', Desestimado: 'Desestimado' },
      reportsEmpty: 'Sin reportes que coincidan con el filtro.',
      colReportedBy: 'Reportado por',
      colRecognitionFrom: 'Reconocimiento de',
      colTo: 'Para',
      colDetail: 'Detalle',
      colReason: 'Motivo',
      colDate: 'Fecha',
      colStatus: 'Estado',
      colActions: 'Acciones',
      // RF-090 — botón ✉️: escala el caso al admin de la OU/país sin esperar al digest semanal.
      notifyAdmin: 'Avisar al admin',
      notifyAdminHint: 'Envía ahora un aviso al administrador de la unidad de este reconocimiento, sin esperar al resumen semanal.',
      notifyAdminConfirm: '¿Enviar un aviso al administrador de la unidad de {{name}}? Se manda un correo de inmediato.',
      notifyAdminSent: 'Aviso enviado al administrador.',
      notifyAdminError: 'No se pudo enviar el aviso al administrador.',
      // RF-090 — previsualización de destinatarios: el ✉️ decía «enviado» aunque no llegara a nadie.
      notifyPreviewTitle: 'Este aviso llegará a:',
      notifyPreviewLoading: 'Resolviendo destinatarios…',
      notifyPreviewEmpty: 'No se resolvió ningún destinatario.',
      notifyPreviewError: 'No se pudo consultar a quién llegaría el aviso.',
      notifyReason: {
        'sin-admins-en-la-ou': 'Esta unidad no tiene ningún administrador dado de alta, ni hay administradores globales a los que escalar el caso.',
        'escalado-a-globales': 'La unidad no tiene administrador propio: el caso se escala a los administradores globales.',
        'admin-sin-correo': 'El administrador no tiene un correo utilizable en el directorio, así que no se le puede escribir.',
        'directorio-no-responde': 'El directorio de usuarios no respondió: no se puede saber a quién habría que avisar.',
        'suprimido-por-allowlist': 'El envío se descartaría: este correo no está en la lista de destinatarios permitidos del servicio de notificaciones.',
        'allowlist-desconocida': 'No se pudo comprobar la lista de destinatarios permitidos; el envío podría descartarse sin dejar rastro.',
        desconocido: 'El aviso no se puede enviar por un motivo que el servicio no supo explicar.',
      },
      deleteLabel: 'Eliminar',
      hideHint: 'Oculta el reconocimiento del muro, lo remueve del medallero y cancela sus puntos.',
      restore: 'Restaurar',
      reopen: 'Reabrir',
      reopenHint: 'Devuelve el caso a la cola como Pendiente y vuelve a ocultar el reconocimiento.',
      viewDetail: 'Ver detalle',
      detailTitle: 'Detalle del reporte',
      whoReported: 'Quién reportó',
      whoWasReported: 'A quién reportaron',
      reportedRecognition: 'Reconocimiento reportado',
      messageUnavailable: 'Texto no disponible.',
      // RF-087 — canalización del caso: correo y OU se pintan siempre, con marcador si faltan.
      dataUnavailable: 'No disponible',
      detailLoading: 'Cargando…',
      detailError: 'No se pudieron cargar los datos de contacto actualizados; se muestran los guardados al momento del reporte.',
      chipOu: 'OU',
      chipBu: 'BU',
      chipSite: 'Site',
    },
    winners: {
      // Task 2.5 — grid de tarjetas de Insignias de Campaña dentro de Ganadores (AdminCampaignBadgeGrid).
      campaignBadges: {
        title: 'Insignias de Campaña',
        permanenceNote: 'Estas insignias son permanentes: no se activan ni desactivan como las de racha; quedan asociadas a la campaña y el año en que se otorgaron.',
        empty: 'No hay insignias de campaña todavía.',
        edit: 'Editar',
        delete: 'Eliminar',
        deleteConfirm: '¿Eliminar la insignia de campaña «{{name}}»? Se perderá su nombre en los 7 idiomas, su icono y su año. Esta acción no se puede deshacer.',
        add: '+ Agregar insignia',
        editTitle: 'Editar insignia de campaña',
        fieldTitle: 'Título',
        fieldYearSubtitle: 'Año / Subtítulo',
        fieldYear: 'Año del premio',
        yearNone: 'Sin año',
        fieldYearHint: 'Se valida al otorgarla: no se puede dar una insignia de un año en una campaña de otro. "Sin año" desactiva la validación.',
        fieldImage: 'Imagen',
        imageUploadHintNew: 'Guarda la insignia primero para poder subir su imagen.',
        imageFormatInvalid: 'El formato de imagen no es válido. Usa PNG, JPG, WEBP o SVG.',
        previewTitle: 'Vista previa',
      },
      bulkTitle: 'Confirmación en lote',
      bulkSelected: '{{count}} seleccionados',
      bulkConfirm: 'Confirmar {{count}}',
      bulkConfirming: 'Confirmando…',
      bulkClear: 'Quitar selección',
      bulkSelectAll: 'Seleccionar todos los pendientes de esta página',
      bulkSelectOne: 'Seleccionar a {{name}}',
      bulkFailed: 'No se pudieron confirmar {{count}}. El resto sí se confirmó; vuelve a intentarlo solo con esos.',
      editTitle: 'Editar ganador — {{nombre}}',
      actionError: 'No se pudo completar la acción.',
      badExtension: 'Formato no admitido. Se aceptan: {{ext}}',
      // No son «Área»/«Site»: el backend resuelve esas dos columnas con el PUESTO y el
      // DEPARTAMENTO de la ficha de la persona (ver AdminWinners.tsx).
      colPuesto: 'Puesto',
      colDepto: 'Departamento',
      colFundamental: 'Fundamental',
      colStatus: 'Estado',
      colUser: 'Usuario',
      /** Fallback bajo el nombre en la celda «Usuario» cuando la persona no tiene correo (ficha
       *  Frontline sin correo): en vez del `userId` crudo, el número de nómina con nota — ver
       *  AdminWinners.tsx. */
      colUserNomina: 'Nómina: {{nomina}}',
      colYear: 'Año',
      colBadge: 'Insignia',
      badgeNone: 'Sin insignia',
      exportFiltered: 'Descarga en Excel los ganadores que muestran los filtros actuales',
      exportEmpty: 'No hay ganadores que exportar con estos filtros',
      exporting: 'Exportando…',
      exportTruncated: 'La descarga se limitó a 5000 filas. Afina los filtros para exportar el resto.',
      exportError: 'No se pudo completar la descarga. Vuelve a intentarlo.',
      confirmAction: 'Confirmar como ganador',
      confirmDelete1: '¿Eliminar a {{nombre}} de la lista de ganadores?',
      confirmDelete2: 'Esta acción no se puede deshacer y queda registrada. ¿Confirmas?',
      deleteTitle: 'Eliminar ganador',
      deleteConfirm: 'Eliminar',
      countryAll: 'País: Todos',
      editAction: 'Editar',
      editClosed: 'Fuera del periodo de edición.',
      editWindowNote: 'Puedes editar un ganador hasta 1 mes después de cargarlo. El Admin General puede editar cualquier ganador de los últimos 3 años.',
      exportNominations: 'Exportar nominaciones',
      exportWinners: 'Exportar ganadores',
      exportNominationsTruncated: 'La descarga se limitó a 5000 filas. Elige una campaña con menos nominaciones o vuelve a intentarlo por partes.',
      exportNominationsEmpty: 'No hay nominaciones que exportar con esta campaña.',
      exportPending: 'El exportable se conecta en el siguiente paquete.',
      filterCountry: 'País',
      filterFundamental: 'Fundamental',
      filterYear: 'Año',
      filtersToggle: 'Filtros',
      flowHint: 'Los ganadores se cargan por archivo. El comportamiento es: sube la plantilla → se refleja aquí → confirmas como ganador final.',
      fundamentalAll: 'Fundamental: Todos',
      fundamentalNone: 'Sin fundamental',
      importErrorsTitle: 'Filas rechazadas',
      importSummary: '{{importados}} de {{total}} filas importadas · {{rechazados}} rechazadas.',
      manageTitle: 'Gestión de Ganadores',
      moduleHint: 'Activa para habilitar la carga de ganadores y asignación de insignias.',
      moduleOffWarn: 'Módulo de Ganadores desactivado. Por ahora este ajuste solo se guarda: no cambia lo que ven los usuarios.',
      moduleSaveError: 'No se pudo guardar el cambio del módulo de Ganadores. Intenta de nuevo.',
      moduleTitle: 'Módulo de Ganadores',
      needsCsv: 'Es un libro de Excel binario y no se puede leer. Ábrelo y guárdalo como CSV (UTF-8) antes de cargarlo.',
      noResults: 'Sin ganadores que coincidan con el filtro.',
      ouAll: 'OU: Todas',
      pagerInfo: 'Página {{page}} de {{paginas}} · {{total}} ganadores',
      searchByName: 'Buscar por nombre…',
      statusConfirmed: '✓ Confirmado',
      statusPending: '⏳ Pendiente',
      uploadFile: 'Cargar Excel',
      uploadCampaign: 'Campaña del padrón',
      uploadMode: 'Edición del padrón',
      uploadModeCurrent: 'Vigente',
      uploadModeHistoric: 'Histórica',
      uploadOpen: 'Cargar padrón',
      uploadOpenHint: 'Abre el asistente para subir el padrón de ganadores, vigente o histórico.',
      uploadModalTitle: 'Cargar padrón de ganadores',
      uploadModalToggleHint: 'Elige "Vigente" si el padrón pertenece a una campaña activa en el sitio. Elige "Histórico" para cargar premios de años anteriores que no están documentados como campaña.',
      uploadBadge: 'Insignia',
      uploadBadgeHint: 'Todas las filas del archivo van a recibir ESTA insignia. Elígela antes de subir el archivo.',
      uploadBadgePick: 'Elige la insignia…',
      uploadBadgeClarify: 'La insignia no es una campaña: es la imagen que la persona verá como premio ganado (por ejemplo, una medalla o un trofeo).',
      pickBadgeFirst: 'Elige primero la insignia que van a recibir los ganadores de este archivo.',
      uploadHistoricWarning: 'Los datos históricos se guardan directo, sin ligarse a ninguna campaña. Revisa nombre, correo e insignia antes de subir.',
      helpOpen: 'Ayuda para cargar el padrón',
      helpModalTitle: '¿Cómo cargo el padrón de ganadores?',
      helpIntroVigente: 'Vigente: úsalo cuando el premio pertenece a una campaña que existe en el sitio, activa ahora mismo. Eliges la campaña y la insignia (la imagen que van a ver como premio ganado) y descargas la plantilla: solo pide el correo o número de nómina de la persona. El nombre, el año y su OU/planta el sistema ya los tiene — no hace falta escribirlos.',
      helpIntroHistorico: 'Histórico: úsalo cuando el premio es de una campaña vieja que ya no existe en el sitio, o de la que no tienes registro. NO eliges campaña: en su lugar eliges UNA insignia (la imagen que se les va a mostrar como premio ganado, no el nombre de una campaña), que se le va a poner a TODAS las personas del archivo. Descargas la plantilla de 2 columnas (Nombre y Correo o Nómina), la llenas y la subes.',
      helpDirectorio: 'El correo o la nómina tienen que existir en el directorio de la empresa. Si no encuentra ninguno de los dos, esa fila se rechaza y el resto del archivo sí se carga. Si la persona no tiene correo (por ejemplo, personal de planta), escribe su número de nómina en esa misma columna — no hace falta el correo si ya pusiste la nómina.',
      helpNoDownload: 'Si intentas descargar un archivo y no hay ningún dato para mostrar, no se descarga nada: se te avisa en la pantalla.',
      downloadTemplateHint: 'Descarga un Excel en blanco con las columnas correctas para este modo, en tu idioma.',
      downloadTemplateCurrent: 'Descargar plantilla vigente',
      downloadTemplateHistoric: 'Descargar plantilla histórica',
      uploadFileHint: 'Sube el Excel ya lleno con los datos del padrón.',
      importWizard: {
        subtitle: 'Sube el padrón, revisa el resultado antes de confirmar y descarga los errores si algo falla.',
        colNombreDesc: 'Nombre del ganador, tal como se mostrará.',
        colNombreDescVigente: 'Nombre del ganador. Puedes dejarlo vacío: si no lo escribes, se usa el nombre que la persona ya tiene registrado en la empresa.',
        colEmailDesc: 'Correo O número de nómina de la persona — basta con uno de los dos; identifica a quién se le otorga el premio.',
        colFundamentalDesc: 'Fundamental reconocido (nombre en cualquier idioma o código del catálogo). Se ignora si no coincide con ninguno.',
        badgePreviewHint: 'Así vas a ver la insignia — es exactamente lo que va a recibir cada ganador de este archivo.',
        dropHint: 'Arrastra tu archivo Excel o CSV aquí, o haz clic para elegirlo.',
        reviewHint: 'Esto es una VALIDACIÓN: todavía no se guarda nada. Revisa el resumen y, si hace falta, vuelve atrás para elegir un archivo corregido.',
        previewPending: 'Validando archivo…',
        noErrors: 'Sin errores — todas las filas son válidas.',
        fileLevelError: 'Archivo/selección',
        confirmPending: 'Guardando…',
      },
      filterEstado: 'Estado',
      estadoAll: 'Estado: Todos',
      uploadCampaignPick: 'Elige la campaña…',
      pickCampaignFirst: 'Elige primero la campaña a la que pertenece el padrón.',
      exportNominationsCatalogError: 'No se pudo cargar el catálogo de Fundamentales/Hábitos: la exportación podría salir incompleta. Vuelve a intentarlo.',
      yearAll: 'Año: Todos',
      desc: 'Registro de ganadores de Brillamos Juntos.',
      title: 'Ganadores',
      descLong: 'Ganadores por campaña/OU. Alta manual e importación CSV del histórico con feedback por fila.',
      filterCampaign: 'Campaña',
      campaignIdHint: 'Id de campaña',
      filterOu: 'OU',
      ouHint: 'Id de OU',
      add: 'Agregar ganador',
      addTitle: 'Nuevo ganador',
      fieldCampaign: 'Campaña',
      fieldUser: 'Usuario',
      fieldName: 'Nombre',
      fieldOuName: 'OU',
      fieldCountry: 'País',
      fieldPosition: 'Posición',
      save: 'Guardar',
      importTitle: 'Importación CSV',
      importHint: 'Descarga la plantilla, complétala y súbela. La importación es idempotente por campaña + usuario.',
      downloadTemplate: 'Descargar plantilla',
      uploadCsv: 'Subir CSV',
      templateError: 'No se pudo descargar la plantilla.',
      importError: 'No se pudo procesar la importación.',
      deleteError: 'No se pudo eliminar este ganador.',
      totalRows: 'Filas totales',
      imported: 'Importados',
      rejected: 'Rechazados',
      row: 'Fila',
      reason: 'Motivo',
      empty: 'No hay ganadores para los filtros.',
      colPosition: 'Posición',
      colName: 'Nombre',
      colOu: 'OU',
      colCountry: 'País',
      colCrossed: 'Origen cruzado',
      colDate: 'Registrado',
      // Task 16 — encabezados del export crudo de nominaciones (i18n, ya no español literal).
      nominationsExport: {
        nomineeName: 'Nominador: Nombre',
        nomineeEmail: 'Nominador: Correo',
        nomineeEmployeeId: 'Nominador: Nómina',
        nomineeOu: 'Nominador: OU',
        nomineeBu: 'Nominador: BU',
        nomineeSite: 'Nominador: Site',
        nomineeDepartment: 'Nominador: Puesto',
        onBehalfOfName: 'En nombre de: Nombre',
        onBehalfOfEmail: 'En nombre de: Correo',
        onBehalfOfEmployeeId: 'En nombre de: Nómina',
        onBehalfOfOu: 'En nombre de: OU',
        onBehalfOfBu: 'En nombre de: BU',
        onBehalfOfSite: 'En nombre de: Site',
        onBehalfOfDepartment: 'En nombre de: Puesto',
        candidateName: 'Candidato: Nombre',
        candidateEmail: 'Candidato: Correo',
        candidateEmployeeId: 'Candidato: Nómina',
        candidateOu: 'Candidato: OU',
        candidateBu: 'Candidato: BU',
        candidateSite: 'Candidato: Site',
        candidateDepartment: 'Candidato: Puesto',
        date: 'Fecha',
        year: 'Año',
        month: 'Mes',
        habitPrefix: 'Hábito',
        comment: 'Comentario',
        streakBadge: 'Insignia de racha',
        fromDayToDay: 'Viene del día a día',
        status: 'Estado',
        type: 'Tipo',
        audienceNominee: 'Audiencia nominador',
        audienceCandidate: 'Audiencia candidato',
        points: 'Puntos',
        retiredHabitsGroup: 'Otros / hábitos retirados',
      },
    },
    campaigns: {
      desc: 'Wizard de campañas de reconocimiento.',
      statusDivider: 'Estatus de campañas',
      title: 'Campañas',
      descLong: 'Lista de campañas y wizard de 5 pasos: Info, Audiencia, Configuración, Documentos y Publicación.',
      filterAll: 'Todas',
      status: {
        Borrador: 'Borrador', Activa: 'Activa', Finalizada: 'Finalizada', PendienteAprobacion: 'Pendiente de aprobación',
        // Bug UAT #114 — «Activa» significaba dos cosas: corriendo, o marcada activa
        // pero fuera de su ventana de fechas (el colaborador no la ve).
        ActivaVencida: 'Activa · fuera de ventana',
        ActivaPorIniciar: 'Activa · aún no inicia',
        ActivaVencidaHint: 'La campaña sigue marcada como activa, pero su vigencia ya terminó: los colaboradores de su alcance no la ven.',
        ActivaPorIniciarHint: 'La campaña está activa pero su fecha de inicio aún no llega.',
      },
      approvals: 'Aprobaciones',
      new: 'Nueva campaña',
      empty: 'No hay campañas.',
      colName: 'Nombre',
      colType: 'Tipo',
      colStatus: 'Estado',
      colScope: 'Alcance',
      allScopes: 'Todas las OUs',
      editBtn: 'Editar',
      duplicate: 'Duplicar',
      panic: 'Detener Campaña',
      panicConfirm: '¿Detener esta campaña inmediatamente?',
      deactivateConfirmTitle: 'Detener excepción por OU',
      deactivateConfirmMsg: '¿Confirmas detener esta excepción por OU? Dejará de aplicar para su alcance de inmediato.',
      type: { Fundamentales: 'Fundamentales', Brillamos: 'Brillamos', Personalizada: 'Personalizada' },
      wizardEditTitle: 'Editar campaña',
      wizardNewTitle: 'Nueva campaña',
      wizardSub: 'Completa los 6 pasos para crear o editar la campaña.',
      backToList: 'Volver a la lista',
      step: { info: 'Info', design: 'Diseño', audience: 'Audiencia', config: 'Configuración', documents: 'Documentos', publish: 'Publicar' },
      tabFundamentales: 'Fundamentales',
      tabBrillamos: 'Brillamos Juntos',
      tabPersonalizadas: 'Personalizadas',
      fundActiveTitle: 'Siempre Activo',
      fundRules: 'Reglas de envío',
      fundActiveDesc: 'Fundamentales es la base del programa de reconocimiento. No se puede desactivar, solo configurar sus reglas.',
      fundConfigNote: 'La configuración detallada de reglas y topes de envío se administra en la sección Gestión.',
      globalPanic: 'Detener Todas las Campañas',
      globalPanicConfirm: '¿Finalizar de inmediato TODAS las campañas Brillamos activas? Esta acción no se puede deshacer.',
      globalPanicDone: '{{count}} campaña(s) finalizada(s).',
      docCategoria: 'Categoría',
      docCatNone: 'Sin categoría',
      fieldType: 'Tipo de campaña',
      fieldName: 'Nombre',
      fieldDescription: 'Descripción',
      fieldSlug: 'Slug de la landing',
      fieldScope: 'Alcance (OUs)',
      fieldExclusions: 'Exclusiones',
      fieldStart: 'Fecha de inicio',
      fieldEnd: 'Fecha de fin',
      fieldTimezone: 'Zona horaria',
      fieldStreakMinimum: 'Mínimo de racha de la campaña',
      streakMinimumInherit: 'Usa el global',
      streakMinimumHint: 'Envíos que exige esta campaña para sumar racha en el período (1-20). Vacío = se aplica el mínimo global de Gestión.',
      streakMinimumLocked: 'La campaña ya arrancó: el mínimo de racha no puede cambiar sin recalificar el período en curso.',
      fieldRecognitionsLimitOwn: 'Tope de envíos de la campaña',
      recognitionsLimitOwnInherit: 'Usa el global',
      recognitionsLimitNotApplicable: 'No aplica (sin tope de envíos)',
      recognitionsLimitNotApplicableShort: 'Sin tope',
      fieldSameFundamentalLimit: 'Veces mismo fundamental a la misma persona',
      sameFundamentalInherit: 'Usa el global',
      sameFundamentalNotApplicable: 'No aplica (sin límite)',
      sameFundamentalNotApplicableShort: 'Sin límite',
      recognitionsLimitOwnHint: 'Envíos que permite esta campaña por periodo. Vacío = se aplica el tope global de Gestión. Editable en cualquier momento, incluso con la campaña ya iniciada.',
      fieldWrappedRelease: 'Release del Wrapped',
      wrappedReleaseOnFinish: 'Al finalizar la campaña',
      wrappedReleaseHint: 'Día en que el Wrapped queda visible para el alcance de esta campaña, en su misma zona horaria. Vacío = se libera cuando la campaña pase a Finalizada.',
      visibility: 'Visibilidad',
      visSender: 'Mostrar remitente',
      visFundamental: 'Mostrar fundamental',
      visText: 'Mostrar texto',
      visHabit: 'Mostrar hábito',
      visSent: 'Contador de enviados',
      visReceived: 'Contador de recibidos',
      visAnonymous: 'Permitir anónimos',
      visBulk: 'Carga masiva CSV',
      visReactions: 'Reacciones (👏❤️😊🎉👍)',
      visCampaignTag: 'Mostrar etiqueta de campaña',
      visFromFundamentals: 'Permitir enviar desde Fundamentales',
      visSendingDisabled: 'Desactivar envío de reconocimiento',
      anonymousOverrideLabel: 'Reconocimientos anónimos',
      anonymousOverrideInherit: 'Heredar de Gestión',
      anonymousOverrideAllow: 'Permitir',
      anonymousOverrideDeny: 'No permitir',
      anonymousOverrideHint: 'Aplica SOLO a esta campaña. Si se deja en "Heredar de Gestión", esta campaña usa la configuración global.',
      points: 'Puntos',
      pointsLocked: 'Los puntos son inmutables: la campaña ya arrancó.',
      pointsHint: 'Solo Europa; el frontend nunca muestra los puntos.',
      applyPoints: 'La campaña otorga puntos',
      brillamosRecurringDesc: 'Campaña recurrente de nominación por Fundamentales.',
      paisScheduleTitle: 'Horarios y Fechas por País',
      paisScheduleIntro: 'Configura horarios o fechas diferentes por país. Si no se especifica, hereda el global.',
      paisCol: 'País',
      paisOpen: 'Horario apertura',
      paisClose: 'Horario cierre',
      paisActive: 'Activo',
      paisApplySchedule: 'Aplicar horario',
      paisClearHours: 'Limpiar horario',
      paisOverrideBadge: 'Campaña de OU',
      paisOverrideWins: 'Tiene preferencia sobre esta fila: {{alcance}}.',
      paisOverrideNoSend: 'Envío desactivado',
      paisOverrideDates: 'Fechas {{inicio}} → {{fin}}',
      paisOverrideHours: 'Horario {{inicio}}–{{fin}}',
      paisScheduleNoActive: 'No hay ninguna campaña de Brillamos Juntos activa: los horarios por país se configuran sobre la campaña vigente. Activa una campaña para poder capturarlos.',
      saveDraftFirst: 'Guarda el borrador para gestionar sus documentos.',
      saveDraft: 'Guardar borrador',
      saveDraftLater: 'El borrador se guarda al terminar la configuración. Usa «Siguiente» para avanzar por los pasos.',
      dates: 'Fechas',
      publishRequirements: 'Requiere nombre en los 7 idiomas, al menos una OU de alcance y fechas de inicio y fin. Guardar se habilita al completar la configuración.',
      valNameAllLangs: 'Captura el nombre en los 7 idiomas.',
      valScope: 'Selecciona al menos una unidad organizativa en el alcance.',
      scopeConflict: "Estas unidades ya están en una campaña activa: {{campanas}}. Quítalas del alcance o finaliza esa campaña.",
      valScopeConflict: "El alcance choca con una campaña activa: {{campanas}}.",
      scopeConflictPartial: "Hay más campañas activas de las que se pudieron revisar: la comprobación de conflictos puede estar incompleta.",
      scopeEmpty: "No tienes unidades organizativas en tu alcance para crear campañas. Pide a un administrador global que te asigne un alcance.",
      outOfScopeHint: "Esta campaña incluye unidades organizativas fuera de tu alcance: solo puede editarla un administrador que las alcance todas.",
      valScopeExcludesOwn: "No puedes excluir tu propia unidad organizativa del alcance.",
      valStart: 'Indica la fecha de inicio de la campaña.',
      valEnd: 'Indica la fecha de fin de la campaña.',
      valTimezone: 'Selecciona la zona horaria de la campaña.',
      valDateOrder: 'La fecha de fin debe ser posterior a la de inicio.',
      designMenu: 'Ícono y título en el menú lateral',
      designMenuHint: 'Así aparecerá la campaña en el sidebar de la plataforma para los usuarios.',
      designIcon: 'Ícono',
      designMenuTitle: 'Título en el menú',
      designMenuTitlePh: 'Ej: Innovación LATAM',
      designSections: 'Secciones de la landing',
      designSectionsHint: 'El banner y el formulario de nominación siempre están presentes. Activa las secciones opcionales.',
      designShowStreak: 'Racha de reconocimientos',
      designShowRecent: 'Reconocimientos recientes',
      designBrillamosLocked: 'La identidad de Brillamos Juntos es inmutable: su diseño no se puede editar.',
      approvalSent: 'Solicitud de aprobación enviada.',
      submitApproval: 'Enviar a aprobación',
      submitApprovalConfirmTitle: 'Enviar a aprobación',
      submitApprovalConfirmMsg: '¿Confirmas el envío de esta campaña a aprobación? El Admin General deberá revisarla antes de que quede activa.',
      prev: 'Anterior',
      next: 'Siguiente',
      docLang: 'Idioma',
      docUrl: 'URL del documento',
      docTitle: 'Título',
      addDoc: 'Agregar documento',
      docCategoryRequired: 'Selecciona una categoría antes de agregar el documento.',
      docTitleRequired: 'Completa el título en los 7 idiomas antes de agregar el documento.',
      docsEmpty: 'No hay documentos.',
      docsFallbackNote: 'Si no se cargan documentos aquí, esta campaña muestra los de la sección Documentación de la administración.',
      approvalsTitle: 'Aprobaciones pendientes',
      approvalsSub: 'Campañas que esperan tu aprobación (AdminGlobal).',
      approvalsEmpty: 'No hay aprobaciones pendientes.',
      colCampaign: 'Campaña',
      requestedBy: 'Solicitada por',
      approve: 'Aprobar',
      approveConfirmTitle: 'Aprobar campaña',
      approveConfirmMsg: '¿Confirmas la aprobación de esta campaña? Quedará activa y visible para su alcance.',
      reject: 'Rechazar',
      rejectReason: 'Motivo del rechazo (obligatorio)',
      rejectConfirm: 'Confirmar rechazo',
      viewDetail: 'Ver detalle',
      bannerDesign: 'Diseño del banner',
      bannerScopeLabel: 'Este banner aplica solo a esta campaña; si no se configura, hereda el banner global del programa.',
      bannerDesignHint: 'Cambia de idioma arriba para editar título, subtítulo y logo de ese idioma — la vista previa se actualiza en vivo.',
      bannerTitle1: 'Título (línea 1)',
      bannerTitle2: 'Título (línea 2)',
      bannerSubtitle: 'Subtítulo',
      bannerLogoNote: 'La imagen del logo (PNG por idioma) se podrá subir próximamente.',
      bannerLogo: 'Logo (imagen para este idioma)',
      bannerLogoUpload: 'Subir PNG',
      bannerLogoReset: 'Volver al predeterminado',
      bannerLogoHint: 'Recomendado: PNG transparente ~4:3. Por defecto se muestra el logo de Fundamentales.',
      bannerLogoErrPng: 'El logo debe ser un PNG.',
      bannerLogoErrSize: 'El PNG no debe superar 500 KB.',
      bannerPreview: 'Vista previa',
      bannerPreviewEmpty: 'Título del banner',
      bannerCta: 'Reconocer a alguien',
      brillamosBannerTitle: 'Banner de Brillamos Juntos',
      brillamosBannerHint: 'Personaliza el subtítulo y el logo del hero de Brillamos Juntos por idioma. La vista previa se actualiza en vivo.',
      brillamosBannerLogoHint: 'Recomendado: PNG transparente. Por defecto se muestra el logo Shine de Brillamos.',
      entryPoints: 'Modalidad de reconocimiento (entry points)',
      entry: { A: 'Entry A — Formulario clásico', B: 'Entry B — Post-it interactivo (Word Builder)', both: 'Ambos visibles (A/B test)' },
      commentRequired: 'Comentario obligatorio',
      vista: 'Vista:',
      vistaGlobal: 'Admin Global',
      vistaOu: 'Admin OU / Embajador',
      rulesTitle: 'Reglas de Envío',
      brillamosRulesIntro: 'Estas reglas aplican solo a Brillamos Juntos. Un campo en blanco hereda el valor global de Gestion.',
      ruleMultiPersona: 'Multi-persona',
      ruleMultiFundamental: 'Multi-fundamental',
      ruleBulkCsv: 'Carga masiva CSV',
      ruleReactions: 'Reacciones en el muro',
      ruleSendingDisabled: 'Desactivar envío',
      ruleAnonymousEnabled: 'Permitir reconocimientos anónimos',
      anonymousGestionHint: 'Aplica a todo (Fundamentales, Brillamos y campañas personalizadas) salvo que una campaña defina su propia configuración en el paso Configuración del asistente. No afecta la anonimización automática por GDPR en Europa.',
      ruleMinChars: 'Mín. caracteres',
      moderationTitle: 'Moderación',
      modPostEdit: 'Edición post-envío',
      moderationNote: 'El Botón Reportar y el Filtro de palabras se administran en la sección Moderación.',
      resetToGlobal: 'Restablecer (heredar del global)',
      streakTitle: 'Configuración de Racha (Fundamentales)',
      streakActive: 'Racha activa',
      streakSentNote: 'La racha se calcula por reconocimientos ENVIADOS.',
      streakInProfile: 'Mostrar racha en perfil',
      badgesActive: 'Insignias activas',
      streakPeriod: 'Periodo',
      periodWeekly: 'Semanal',
      periodMonthly: 'Mensual',
      periodDaily: 'Diario',
      limitsTitle: 'Topes (Gestión de Límites)',
      limitsActive: 'Topes activos',
      limitName: 'Nombre',
      limitDescription: 'Descripción',
      limitRecognitionsDesc: 'Máximo de reconocimientos',
      limitFundamentalsDesc: 'Máximo seleccionables por envío',
      limitValue: 'Límite',
      limitFrequency: 'Frecuencia',
      limitActiveCol: 'Activo',
      limitRecognitions: 'Reconocimientos por periodo',
      limitFundamentals: 'Fundamentales por reco',
      perSubmission: 'Por envío',
      readonlyTitle: 'Configuración General — Fundamentales (aplicada por default)',
      readonlyBadge: 'Solo lectura',
      readonlyNote: 'Si deseas agregar una excepción por OU, pasará por aprobación del Admin Global.',
      colDate: 'Fecha',
      exc: {
        title: 'Excepciones por OU',
        intro: 'Excepciones puntuales a la configuración base para un alcance OU/BU/Site concreto. Cada una pasa por aprobación del Admin Global.',
        new: 'Nueva excepción por OU',
        colException: 'Excepción',
        colScope: 'OU / BU / Site',
        colState: 'Estado de la excepción',
        fullOu: 'Toda la OU',
        sites: '{{count}} sites',
        scopePopTitle: 'Sites del alcance',
        stateActive: 'Activa',
        stateInactive: 'Inactiva',
        toggleHint: 'Solo una excepción aprobada se puede activar o desactivar.',
        edit: 'Editar',
        delete: 'Eliminar',
        empty: 'Aún no hay excepciones por OU.',
        deleteTitle: 'Eliminar excepción',
        deleteMsg: 'Esta excepción por OU se eliminará de forma permanente. Esta acción no se puede deshacer.',
        deleteConfirm: 'Eliminar',
        summaryTope: 'Tope: {{max}} recos / {{freq}}',
        summaryDisable: 'Desactivar envío',
        disableTitle: 'Desactivar envío (override)',
        disableNote: 'Bloquea temporalmente el envío de reconocimientos para el alcance seleccionado, sin desactivar el programa. Requiere aprobación del Admin Global.',
        summarySchedule: 'Horario restringido',
        summaryVisibility: 'Visibilidad',
        summaryBanner: 'Banner',
        approvalsTitle: 'Aprobaciones',
        approvalsColSolicitante: 'Solicitante',
        approvalsColAprobador: 'Aprobador',
        approvalsColFecha: 'Fecha',
        approvalsColEstado: 'Estado',
        approved: 'Aprobada',
        pending: 'Pendiente',
        rejected: 'Rechazada',
        approvalsEmpty: 'Aún no hay excepciones por aprobar.',
        pendingBanner: 'Tienes {{count}} excepción(es) esperando tu aprobación.',
        approve: 'Aprobar',
        reject: 'Rechazar',
        rejectReason: 'Motivo del rechazo (obligatorio)',
        rejectConfirm: 'Confirmar rechazo',
        back: 'Excepciones por OU',
        wizardTitle: 'Excepción por OU — Fundamentales',
        wizardTitleBrillamos: 'Excepción por OU — Brillamos Juntos',
        stepScope: 'Alcance',
        stepSchedule: 'Horarios',
        stepBanner: 'Banner',
        // Bug UAT #114 — la «campaña por OU» sobreescribe una campaña activa; sin una debajo no hace nada.
        baseCampaignTitle: 'Campaña base',
        baseCampaignHint: 'Una excepción por OU no funciona sola: SOBREESCRIBE partes de una campaña activa para tu alcance. Si no hay una campaña activa que cubra esas OUs, esta excepción no tendrá ningún efecto. Si lo que necesitas es una campaña propia y completa para la OU, hay que crearla desde Campañas, no aquí.',
        baseCampaignLabel: 'Campaña que se sobreescribe',
        baseCampaignNone: 'Sin declarar (se aplica a la campaña activa que cubra el alcance)',
        baseCampaignNinguna: 'No hay ninguna campaña de Brillamos activa. Crea y activa una antes, o esta excepción no se aplicará a nadie.',
        baseCampaignRequerida: 'Elige la campaña base para poder guardar: sin ella la excepción no se aplicaría a nadie.',
        baseCampaignVentana: 'La campaña base va del {{inicio}} al {{fin}}. Estas fechas son de la campaña, no se editan aquí.',
        baseCampaignSinVentana: 'La campaña base no tiene fechas de vigencia definidas.',
        scheduleWindow: 'Fecha y hora local de la excepción',
        scheduleStart: 'Inicio de la excepción',
        scheduleEnd: 'Fin de la excepción',
        scheduleTz: 'Zona horaria',
        scheduleRestrictTitle: 'Desactivar reconocimientos',
        scheduleRestrictNote: 'Cuando está activo, no se pueden enviar reconocimientos fuera de la fecha y hora configuradas para este alcance. Requiere aprobación del Admin Global.',
        scheduleWindowNota: 'Si capturas una ventana, los envíos de este alcance quedarán restringidos a ella. Déjala vacía para no restringir nada.',
        scheduleInvalid: 'La ventana de horario requiere fecha/hora de inicio y fin, y el fin debe ser posterior al inicio.',
        bannerTitle: 'Banner de Brillamos Juntos (override)',
        bannerIntro: 'Sobrescribe el subtítulo y el logo del banner de Brillamos Juntos solo para el alcance de esta excepción. Si no editas ningún idioma aquí, se mantiene el banner global.',
        bannerScopeLabel: 'Este banner aplica solo al alcance de esta excepción, no al banner global de Brillamos Juntos.',
        stepDocs: 'Documentos',
        stepVisibility: 'Visibilidad',
        scopeIntro: 'Define el alcance organizacional.',
        docsIntro: 'Adjunta documentos específicos para esta excepción por OU.',
        entryPoints: 'Entry Points',
        entryPointMode: 'Puertas de envío habilitadas (override)',
        entryPointModeApp: 'Solo formulario',
        entryPointModePostit: 'Solo post-it interactivo',
        entryPointModeAmbos: 'Ambas',
        visTitle: 'Visibilidad del reconocimiento (override)',
        visIntro: 'Configura qué información se muestra al usuario cuando recibe o consulta un reconocimiento.',
        visText: 'Mostrar texto/comentario del reconocimiento',
        visFundamental: 'Mostrar fundamental asignado',
        visSender: 'Mostrar nombre del remitente',
        visHabit: 'Mostrar Daily Habit seleccionado',
        visRanking: 'Mostrar ranking de otras OUs',
        visMultiFund: 'Permitir múltiples Fundamentales por reconocimiento',
        maxFundamentales: 'Máx. Fundamentales por reconocimiento',
        rulesTitle: 'Reglas de envío (override)',
        ruleMultiPersona: 'Multi-persona',
        ruleComment: 'Comentario obligatorio',
        ruleMinChars: 'Mín. caracteres',
        ruleCsv: 'Carga CSV',
        modTitle: 'Moderación (override)',
        modReport: 'Botón Reportar',
        modEditDelete: 'Botones Editar y Eliminar (solo enviados)',
        streakTitle: 'Racha (override)',
        streakMin: 'Mín. envíos/semana',
        streakPeriod: 'Periodo',
        limitsTitle: 'Topes (override)',
        limitMax: 'Máx. recos',
        limitFreq: 'Frecuencia',
        approvalRequiredTitle: 'Aprobación requerida',
        approvalRequiredMsg: 'Todas las modificaciones deberán ser aprobadas por el Admin Global antes de aplicarse.',
      },
      // C2/P17 — Frecuencia declarativa; el vocabulario sale del Excel del cliente.
      fieldFrecuencia: 'Frecuencia',
      frecuenciaPlaceholder: 'Ej. Mensual, Cada 3 reuniones…',
      frecuencia: {
        mensual: 'Mensual',
        trimestral: 'Cada trimestre',
        cadaNReuniones: 'Cada 3 reuniones',
        porEvento: 'Por evento',
      },
      // C2/P18-bis — deshacer un panico accidental (24 h, misma OU libre).
      undoPanic: 'Reactivar campaña',
      undoPanicConfirm: 'Se reactivará esta campaña y volverá a ser visible en su alcance. Solo se puede dentro de las 24 h siguientes al pánico. Continuar?',
      // C2/P19 — meta de participantes; la ayuda repite la DEFINICIÓN a propósito.
      fieldMetaParticipantes: "Meta de participantes",
      metaParticipantesInherit: "Sin meta",
      metaParticipantesHelp: "Personas distintas que participen, reconociendo o siendo reconocidas. Vacío = sin meta.",
      // WP-15 Task 9 — tooltips de ayuda por toggle (patrón AdminVistas). Una clave por concepto;
      // las variantes de excepción reutilizan la misma clave que su equivalente del wizard principal.
      tooltip: {
        entryPoints: 'Cómo puede reconocer la gente: formulario clásico, post-it interactivo, o ambos a la vez.',
        ruleMultiPersona: 'Permite incluir a más de una persona como receptor en un mismo reconocimiento.',
        ruleMultiFundamental: 'Permite marcar más de un Fundamental en el mismo reconocimiento.',
        commentRequired: 'Exige escribir un comentario para poder enviar el reconocimiento.',
        ruleBulkCsv: 'Habilita la carga masiva de reconocimientos por archivo CSV.',
        ruleReactions: 'Permite que otras personas reaccionen con emojis a un reconocimiento.',
        ruleSendingDisabled: 'Apaga por completo el envío de reconocimientos para este alcance, sin afectar los ya enviados.',
        ruleAnonymousEnabled: 'Permite enviar un reconocimiento sin mostrar el nombre de quien lo envía.',
        modPostEdit: 'Permite editar un reconocimiento ya enviado, dentro de la ventana de edición.',
        antiSpoiler: 'Oculta reconocimientos recientes en Home para no adelantar sorpresas antes del cierre.',
        streakActive: 'Activa el conteo de racha semanal de reconocimientos para esta campaña.',
        dailyHabitsMandatory: 'Exige marcar un hábito diario para que el reconocimiento cuente en la racha.',
        streakInProfile: 'Muestra la racha actual en el perfil público del usuario.',
        badgesActive: 'Activa el otorgamiento de insignias por cumplir metas de racha.',
        limitsActive: 'Activa los topes de envío configurados abajo, por reconocimientos y por Fundamentales.',
        recognitionsLimitActive: 'Aplica el tope de reconocimientos por período a este alcance.',
        recognitionsLimitDisabled: 'Marca «No aplica» para que esta campaña NO tenga tope total de envíos: la persona puede enviar los reconocimientos que quiera en el período, sin importar el tope global de Gestión. Déjalo sin marcar (y el campo vacío) para usar el tope global.',
        streakMinimum: 'Mínimo de reconocimientos que una persona debe ENVIAR en el período para que ese período le cuente para su racha (1-20). Sobreescribe el mínimo global de Gestión solo para esta campaña; vacío = se aplica el global. No se puede cambiar con la campaña ya iniciada.',
        recognitionsLimitOwn: 'Máximo TOTAL de reconocimientos que una persona puede enviar en el período (a quien sea, del fundamental que sea). Sobreescribe el tope global de Gestión solo para esta campaña; vacío = se aplica el global. Editable en cualquier momento, incluso con la campaña iniciada.',
        sameFundamentalLimit: 'Cuántas VECES una persona puede reconocer a otra sobre el MISMO fundamental en el período (a la misma persona). Sobreescribe el valor global de Gestión solo para esta campaña; vacío = se aplica el global. En Europa se mantiene el mínimo legal (GDPR).',
        sameFundamentalLimitDisabled: 'Marca «No aplica» para permitir repetir el mismo fundamental a la misma persona SIN límite, sin importar el global de Gestión. Déjalo sin marcar (y el campo vacío) para usar el global. En Europa el límite legal se mantiene aunque lo marques.',
        fundamentalsLimitActive: 'Aplica el tope de Fundamentales por envío a este alcance.',
        designShowStreak: 'Muestra el bloque de racha en la landing de esta campaña.',
        designShowRecent: 'Muestra los reconocimientos recientes en la landing de esta campaña.',
        visSender: 'Muestra el nombre de quien envía el reconocimiento.',
        visFundamental: 'Muestra el Fundamental asignado en el reconocimiento.',
        visText: 'Muestra el texto o comentario del reconocimiento.',
        visHabit: 'Muestra el hábito diario seleccionado, si aplica.',
        visSent: 'Muestra la pestaña de reconocimientos enviados.',
        visReceived: 'Muestra la pestaña de reconocimientos recibidos.',
        visBulk: 'Habilita la carga masiva por CSV solo para esta campaña.',
        visReactions: 'Habilita las reacciones con emoji solo para esta campaña.',
        visCampaignTag: 'Muestra la etiqueta con el nombre de la campaña en cada post-it.',
        visFromFundamentals: 'Permite iniciar este reconocimiento desde la pantalla de Fundamentales.',
        visSendingDisabled: 'Apaga el envío de reconocimientos solo para esta campaña.',
        applyPoints: 'Los reconocimientos de esta campaña otorgan puntos canjeables. No se puede apagar con la campaña ya iniciada.',
        visRanking: 'Muestra el ranking comparado con otras OUs.',
        visMultiFund: 'Permite marcar más de un Fundamental, como excepción de esta OU.',
        modReport: 'Permite reportar un reconocimiento inapropiado.',
        modEditDelete: 'Habilita editar y eliminar un reconocimiento ya enviado, solo para esta OU. El backend maneja ambos permisos como un único interruptor.',
        scheduleEnabled: 'Restringe el envío de reconocimientos a la ventana horaria definida arriba.',
        disableSend: 'Bloquea el envío de reconocimientos para este alcance concreto.',
        paisActive: 'Si se apaga, la campaña deja de estar activa para este país aunque la fecha y el horario configurados sigan vigentes.',
        paisApplySchedule: 'Si se apaga, la fecha y el horario de esta fila quedan guardados pero SIN aplicarse: el país no tiene restricción de horario. Sirve para dejar una ventana preparada y encenderla más tarde sin volver a capturarla.',
      },
      tooltipAria: 'Ayuda',
    },
    reports: { desc: 'Reportería y analytics del programa.' },
    translate: {
      button: 'Traducir a los demás idiomas',
      buttonFrom: 'Traducir desde {{lang}} a los demás idiomas',
      loading: 'Traduciendo…',
      hint: 'Captura al menos un idioma para poder traducir.',
      error: 'No se pudo traducir automáticamente.',
      sessionExpired: 'Tu sesión expiró. Recarga la página e inicia sesión de nuevo.',
    },
    misSolicitudes: {
      title: "Mis Solicitudes de Campaña",
      desc: "El estado de lo que has propuesto. Puedes retirar una solicitud mientras siga pendiente, y volver a enviarla si fue rechazada.",
      empty: "Todavía no has enviado ninguna solicitud.",
      colCampana: "Campaña",
      colFecha: "Fecha solicitud",
      colEstado: "Estado",
      colComentario: "Comentario",
      colAcciones: "Acciones",
      editar: "Editar",
      retirar: "Retirar solicitud",
      reenviar: "Volver a enviar",
      estado: {
        pendiente: "Pendiente",
        aprobada: "Aprobada",
        rechazada: "Rechazada",
      },
    },
    management: {
      desc: 'Reglas de envío, topes y racha.',
      title: 'Gestión',
      descLong: 'Ajustes globales: descripción de racha ×7, insignias, toggles globales y freeze. Guardado atómico.',
      fixValidation: 'Corrige las validaciones antes de guardar.',
      streakDescription: 'Descripción de la racha',
      fundamentalsTitle: 'Fundamentales disponibles',
      fundamentalsDesc: 'Qué Fundamentales se ofrecen al reconocer. Retirar uno no lo borra del catálogo: deja de aparecer en este programa.',
      fundamentalsLastOne: 'Es el último disponible: si lo retiras, nadie podría enviar un reconocimiento.',
      avatarTitle: 'Configuración de Avatar (Frontline)',
      avatarDesc: 'Los usuarios frontline que ingresan por webapp pueden personalizar un avatar de color. Quienes entran por Teams conservan su foto de perfil.',
      avatarEnabled: 'Avatar personalizable activo',
      avatarSelector: 'Mostrar selector post-registro',
      avatarColors: 'Colores disponibles:',
      placeholderTitle: 'Descripción configurable del campo de texto',
      placeholderDesc: 'El texto de ayuda del campo de mensaje al reconocer. Cada idioma que dejes vacío usa el texto por defecto del producto.',
      placeholderLabel: 'Texto de ayuda del mensaje',
      panicTitle: 'Botón de Pánico — Brillamos Juntos',
      panicDesc: 'Desactiva de inmediato el envío de reconocimientos en todas las campañas activas. Aplica tanto a Brillamos Juntos como a Reconocer (Fundamentales). Solo Admin General.',
      panicToggle: 'Kill Switch Global Brillamos',
      panicActiveHint: 'El envío está DESACTIVADO: nadie puede enviar reconocimientos ahora mismo.',
      panicSameSwitchHint: 'Es un interruptor global: mientras esté activo, ninguna configuración por programa ni por campaña puede volver a habilitar el envío.',
      panicNoActiveCampaign: 'Este interruptor se habilita cuando hay al menos una campaña de Brillamos Juntos activa (RN-C08). Ahora mismo no hay ninguna, así que no hay envíos de campaña que detener.',
      needAllLangs: 'Completa los 7 idiomas.',
      globalToggles: 'Toggles globales',
      streakEnabled: 'Racha activa',
      multinomination: 'Multinominación',
      dailyHabitsMandatory: 'Hábitos diarios obligatorios',
      antiSpoiler: 'Anti-spoiler',
      antiSpoilerTitle: 'Modo Anti-Spoiler (Premiación)',
      antiSpoilerDesc: 'Desactiva temporalmente la vista de perfiles y reconocimientos de terceros durante la premiación anual, para no revelar ganadores.',
      antiSpoilerActivo: 'Anti-Spoiler activo',
      antiSpoilerFrom: 'Desde',
      antiSpoilerTo: 'Hasta',
      antiSpoilerHint: 'Mientras esté activo, los empleados no podrán ver perfiles de compañeros ni el detalle de reconocimientos de terceros.',
      antiSpoilerSinVentana: 'Sin fechas, protege mientras el interruptor esté encendido.',
      antiSpoilerVentanaInvertida: '«Desde» es posterior a «Hasta»: así la ventana no protege nunca. Corrígela para poder guardar.',
      wrappedByOu: 'Wrapped por OU',
      reactionsEnabled: 'Reacciones (👏❤️😊🎉👍)',
      allowPromoteToBrillamos: 'Permitir enviar a Brillamos',
      allowPostEdit: 'Edición post-envío',
      postEditTitle: 'Edición de Reconocimientos Enviados',
      postEditDesc: 'Permite al emisor editar el mensaje de un reconocimiento ya enviado. Deshabilitado por defecto.',
      postEditWindow: 'Ventana de edición',
      postEditWindowOpt: { '24h': '24 horas', '48h': '48 horas', '7d': '7 días', unlimited: 'Sin límite' },
      streakPerPersonCapEnabled: 'Tope por persona en racha',
      streakPerPersonCap: 'Máx. por persona (racha)',
      weeklyMinimum: 'Mínimo por período',
      periodicity: 'Periodicidad',
      period: { weekly: 'Semanal', monthly: 'Mensual' },
      periodicityHint: 'El mínimo se exige sobre el período elegido: con Mensual, la racha suma o se rompe por mes calendario, no por semana.',
      periodicityMonthlyWarning: 'Con Mensual la racha cuenta MESES consecutivos y la aplicación ya lo refleja (widget, Perfil, Wrapped y umbrales). Quedan DOS decisiones de Producto antes de activarlo en producción: RF-038 define los umbrales de insignia en semanas (1/4/8/12/20), así que la de 4 se alcanzaría a los 4 meses; y el tope anti-abuso de 2 reconocimientos por persona pasa de aplicarse por semana a por mes, lo que puede hacer inalcanzable un mínimo alto en equipos pequeños.',
      freezeFrom: 'Freeze desde',
      freezeTo: 'Freeze hasta',
      badges: 'Insignias',
      noBadges: 'No hay insignias configuradas.',
      badge: 'Insignia',
      weeksRequired: '{{count}} semanas',
      weeksRequiredOne: '{{count}} semana',
      weeksRequiredMany: '{{count}} semanas',
      badgeName: 'Nombre de la insignia',
      badgeIcon: 'Icono',
      badgeColor: 'Color',
      weeks: 'Semanas requeridas',
      notApplicable: 'No aplica',
      iconFormatInvalid: 'El formato de imagen no es válido. Usa PNG, JPG, WEBP o SVG.',
      addBadge: '+ Agregar insignia',
      editBadge: 'Editar',
      deleteBadge: 'Eliminar',
      deleteBadgeConfirm: '¿Eliminar la insignia «{{name}}»? Se perderán su nombre en los 7 idiomas, su icono y su umbral. El borrado se aplica al Guardar.',
      badgeActive: 'Activa',
      badgeInactive: 'Inactiva',
      imageUploadHintNew: 'Guarda la insignia primero para poder subir el ícono.',
      previewTitle: 'Vista previa',
      saveBadgeChanges: 'Guardar cambios',
    },
    // FASE 7 (paridad demo, H-93/H-94/H-95) — Admin › Notificaciones (REQ-135).
    notifications: {
      title: 'Configuración de Notificaciones',
      desc: 'Configura qué avisos por correo se envían y a qué nivel de la organización. Los valores no definidos en este nivel se heredan del siguiente.',
      precedenceTitle: 'Cómo se resuelve la configuración',
      precedence1: 'Precedencia: Site > BU > OU > Global. Gana el valor definido en el nivel más específico.',
      precedence2: 'Un toggle «Heredado» no está apagado: toma el valor del nivel inferior. Solo se guarda lo que definas aquí.',
      precedence3: 'Cada persona puede además desactivar sus propios correos desde su perfil; esa preferencia nunca reactiva lo que aquí se apague.',
      scopeTitle: 'Nivel de configuración',
      scopeUnit: 'Unidad',
      scopePick: 'Selecciona una unidad…',
      scopeRequired: 'Selecciona una unidad para ver y editar su configuración.',
      scopeOuContext: 'OU de la unidad',
      scopeOuFirst: 'Selecciona antes una OU…',
      unsavedLock: 'Tienes cambios sin guardar; el nivel queda fijo hasta que guardes o los descartes.',
      discard: 'Descartar cambios',
      scope: { global: 'Global (todo el tenant)', ou: 'OU', bu: 'Business Unit', site: 'Site' },
      group: { email: 'Correo', categories: 'Tipos de aviso', summary: 'Resumen periódico', blocked: 'Correos bloqueados' },
      blocked: {
        desc: 'Direcciones que no recibirán ningún correo del programa, sea cual sea su configuración personal.',
        scopeWarning: 'El bloqueo alcanza al tenant ENTERO, no solo a este nivel: un correo bloqueado aquí queda bloqueado en todas las OUs. Y manda por encima del interruptor maestro.',
        placeholder: 'correo@empresa.com',
        add: 'Bloquear',
        remove: 'Quitar el bloqueo de {{email}}',
        empty: 'No hay ningún correo bloqueado.',
      },
      design: {
        title: 'Diseño de Emails',
        desc: 'Así se ven hoy: los Fundamentales usan un estilo cálido y Shine Together uno oscuro con estrellas. El diseño de cada correo se ajusta directamente en la plantilla, no desde aquí.',
        fund: { name: 'Fundamentales', style: 'Estilo cálido · Crema/Naranja' },
        shine: { name: '✨ Shine Together', style: 'Estilo oscuro · Estrellas/Morado' },
      },
      broadcast: {
        title: 'Avisos del sistema',
        desc: 'Para mantenimientos, suspensiones o cualquier aviso puntual. Se manda con la plantilla ya diseñada: solo escribe el mensaje.',
        overridesHint: '🔴 Este aviso llega a TODAS las personas, también a quien haya apagado sus notificaciones. No es contenido del programa: es información sobre la herramienta.',
        kindLabel: 'Tipo de aviso',
        kind: { maintenance: 'Mantenimiento programado', suspension: 'Suspensión temporal', restored: 'Servicio restablecido', general: 'Aviso general' },
        subject: 'Asunto',
        subjectPlaceholder: 'Mantenimiento programado — sábado 2am',
        message: 'Mensaje',
        messagePlaceholder: 'Mensaje para los usuarios...',
        everyone: 'Todos los usuarios',
        singleOu: 'Una OU específica',
        chooseOu: 'Elige una OU',
        send: 'Enviar aviso ahora',
        error: 'No se pudo enviar el aviso.',
        sentSummary: 'Enviado a {{sent}} de {{recipients}} personas.',
        skipped: '· {{count}} sin identidad resoluble, no recibieron el aviso.',
      },
      channel: { inapp: 'Campana', email: 'Correo', teams: 'Teams' },
      tables: {
        shine: '✨ Notificaciones — Shine Together',
        admin: '🛡️ Notificaciones — Admin',
        colType: 'Tipo',
        colSubject: 'Asunto (ES)',
        colLanguages: 'Idiomas',
        editSubject: 'Editar el asunto de «{{row}}» en los 7 idiomas',
        subjectByLanguage: 'Asunto por idioma',
        close: 'Cerrar',
        saveSubject: 'Guardar asunto',
        nineRows: 'Nueve filas y no trece: cuatro de las que la maqueta dibuja no corresponden a ningún aviso que el sistema emita hoy.',
        rows: {
          'campaign-new': { name: 'Campaña nueva lanzada', trigger: 'Un administrador activa una campaña' },
          'campaign-ending': { name: 'Campaña por terminar', trigger: 'Últimos días para nominar' },
          'recognition-sent': { name: 'Reconocimiento enviado a Brillamos', trigger: 'Confirmación de que sumó a la campaña' },
          'ranking-position': { name: 'Posición en ranking', trigger: 'Subes en el leaderboard' },
          'campaign-approval': { name: 'Solicitud de campaña por localidad', trigger: 'Un Admin de OU crea una solicitud → Admin Global' },
          'moderation-case-alert': { name: 'Reporte de moderación', trigger: 'Hay un reporte nuevo pendiente para el Admin de la OU' },
          'moderation-educational': { name: 'Mensaje reportado, aviso al emisor', trigger: 'Avisa a quien envió el reconocimiento de que fue reportado' },
          'low-participation-alert': { name: 'Alerta de baja participación', trigger: 'Una campaña va por debajo del umbral de participación' },
          'pending-nomination-manager': { name: 'Nominación pendiente (líder)', trigger: 'Una nominación requiere aprobación' },
        },
      },
      master: {
        label: 'Notificaciones por Correo',
        desc: 'Interruptor maestro: si está apagado no se envía ningún correo del programa en este alcance. No afecta a Teams ni a la campana.',
      },
      cat: {
        recognitionReceivedEnabled: { label: 'Reconocimientos recibidos', desc: 'Aviso a la persona cuando alguien la reconoce.' },
        streakAndBadgesEnabled: { label: 'Rachas e insignias', desc: 'Recordatorios de racha e insignias desbloqueadas.' },
        campaignsEnabled: { label: 'Campañas', desc: 'Nueva campaña, campaña por terminar, ganadores y aprobaciones.' },
        digestEnabled: { label: 'Resumen semanal', desc: 'Digest con la actividad acumulada de la semana.' },
      },
      monthly: {
        label: 'Resumen mensual',
        desc: 'Desactivado por defecto. Actívalo solo si esta unidad quiere además un resumen mensual.',
      },
      masterOffHint: 'Los tipos individuales solo operan con el interruptor maestro encendido.',
      inherited: 'Heredado',
      inApp: { label: 'Notificaciones In-App (campanita)', desc: 'La campanita del portal. No depende del interruptor de correo: es un canal aparte.' },
      teams: { label: 'Activity Feed de Teams', desc: 'El aviso en el feed de actividad de Teams, para quien tiene cuenta corporativa.' },
      frequency: {
        label: 'Frecuencia de envío (email)',
        desc: 'Cada cuánto se agrupan los avisos en un resumen. No afecta a los correos por evento.',
        opt: {
          immediate: 'Inmediato (por evento)',
          daily: 'Resumen diario',
          weekly: 'Resumen semanal',
          biweekly: 'Resumen quincenal (cada 2 semanas)',
        },
        immediateHint: 'Con «Inmediato» no se manda ningún resumen, aunque su categoría siga encendida: cada aviso sale por su cuenta.',
      },
      resetToInherited: 'Volver a heredado',
      active: 'activos',
      saved: '¡Cambios guardados!',
      loadError: 'No se pudo cargar la configuración de este nivel.',
      saveError: 'No se pudo guardar la configuración. Inténtalo de nuevo.',
    },
    views: {
      title: 'Vistas de Usuario',
      desc: 'Vistas visibles para el empleado y microsites.',
      descLong: 'Qué vistas ofrece cada OU a sus colaboradores. Compatible desktop + móvil.',
      scope: 'Nivel de configuración',
      scopeGlobal: 'Global (todas las OUs)',
      unsavedLock: 'Guarda o descarta los cambios antes de cambiar de nivel.',
      infoAria: 'Ayuda sobre {{label}}',
      micrositesTitle: 'URLs de Micrositios por Fundamental',
      micrositesDesc: 'Enlace externo con más información de cada Fundamental. Déjalo vacío si no hay micrositio.',
      card: {
        medallero: { label: 'Medallero', desc: 'Enviados + recibidos' },
        perfilUsuario: { label: 'Perfil de usuario', desc: 'Recibidos reciente→antiguo' },
        enviarReconocimiento: {
          label: 'Enviar reconocimiento', desc: 'Según config del admin',
          tooltip: 'Muestra el botón y el formulario para reconocer a un compañero. Se combina con el interruptor general de envíos: si ese está apagado, esta vista no aparece aunque esté encendida aquí.',
        },
        historicoPorAnio: {
          label: 'Histórico por año', desc: 'Año actual primero',
          tooltip: 'Deja ver el historial de reconocimientos agrupado por año, con el año en curso primero. También depende de que la campaña activa tenga el histórico habilitado.',
        },
        leaderboard: {
          label: 'Leaderboard', desc: 'Ranking',
          tooltip: 'Muestra el ranking de quienes más reconocimientos han enviado o recibido. Es la única vista que viene apagada por defecto.',
        },
        feedActividad: { label: 'Feed de actividad', desc: 'Timeline reciente' },
        resumenMensual: {
          label: 'Resumen mensual', desc: 'Wrap-up tipo Spotify',
          tooltip: "Activa el resumen tipo 'Wrapped' con las cifras del período para cada colaborador. Solo se ve si el Wrapped está habilitado para la OU y la campaña ya cerró.",
        },
        busquedaCompaneros: {
          label: 'Búsqueda compañeros', desc: 'Ver medalleros de otros',
          tooltip: 'Permite buscar y ver el medallero de reconocimientos de otros compañeros. Se oculta automáticamente mientras el Modo Anti-Spoiler esté activo, para no arruinar sorpresas antes de una premiación.',
        },
        vistaFundamentales: {
          label: 'Vista Fundamentales', desc: 'Info de cada fundamental',
          tooltip: 'Muestra la constelación con la información de cada Fundamental de la cultura dentro de la pantalla de Brillamos Juntos.',
        },
        banderaReportar: {
          label: 'Bandera de reportar', desc: 'Reportar reconocimientos inapropiados',
          tooltip: 'Agrega un botón para que los colaboradores puedan reportar un reconocimiento inapropiado. También depende de que el botón de reportar esté habilitado en Moderación.',
        },
        recordatorioDiario: { label: 'Recordatorio diario', desc: 'Campaña de reconocer cada día' },
        verATuEquipo: {
          label: 'Ver a tu equipo', desc: 'Solo para líderes/managers',
          tooltip: 'Permite a líderes y managers ver los reconocimientos de las personas a su cargo. Solo aplica a quien tenga permiso de métricas de equipo y aparezca como líder en el organigrama.',
        },
      },
      compose: {
        sending: 'Además depende del interruptor de pánico: con el envío desactivado, esta vista no aparece aunque esté encendida aquí.',
        campaign: 'Además depende del toggle de histórico de la campaña activa (RN-PR09).',
        wrapped: 'Además depende de que la OU tenga el Wrapped habilitado y de que su campaña haya cerrado.',
        antiSpoiler: 'Además depende del Modo Anti-Spoiler: mientras su ventana está activa, esta vista se oculta.',
        report: 'Además depende del toggle «Botón Reportar» de la sección Moderación.',
        manager: 'Además depende de ser líder en el organigrama y de tener el permiso de métricas de equipo.',
      },
    },
    docs: {
      desc: 'Documentos corporativos y legales.',
      legalTab: 'Bases legales',
      privacyTab: 'Aviso de privacidad',
      corpTab: 'Corporativos',
      pillsTab: 'Pills de Usuario',
      bibliotecaTab: 'Biblioteca',
      legalesTab: 'Docs Legales',
      gestionTitle: 'Gestión de Documentación',
      gestionDesc: 'Configura los accesos rápidos de usuario, gestiona la biblioteca de archivos y los documentos legales obligatorios.',
      pills: {
        nueva: 'Agregar Pill',
        sectionTitle: 'Accesos Rápidos (Pills)',
        sectionSubtitle: 'Cápsulas de acceso rápido visibles en la interfaz del usuario. Define nombre, ícono, color y el contenido que abren al hacer clic.',
        editar: 'Editar pill',
        titulo: 'Título',
        tipo: 'Tipo',
        tipos: { documento: 'Documento', url: 'Enlace', video: 'Video' },
        icono: 'Ícono',
        color: 'Color',
        orden: 'Orden',
        documento: 'Documento corporativo',
        elegirDocumento: 'Elegir documento…',
        sinDocumentos: 'No hay documentos corporativos disponibles. Súbelos en la pestaña Corporativos.',
        url: 'URL de destino',
        visibilidad: 'Visibilidad por OU',
        visibilidadHint: 'Sin OU seleccionada = visible para todas las unidades.',
        activa: 'Pill activa (visible en el rail)',
        activaSi: 'Activa',
        activaNo: 'Inactiva',
        estado: 'Estado',
        vistaPrevia: 'Vista previa',
        nombre: 'Nombre',
        tipoContenido: 'Tipo de contenido',
        documentoColumna: 'Documento vinculado',
        documentoNoEncontrado: 'Documento no encontrado',
        documentoAlcanceIncompleto: 'No cubre todas las OUs de esta pill',
        sinTitulo: 'Sin título',
        todas: 'Todas',
        vacio: 'Aún no hay accesos rápidos configurados.',
        eliminar: 'Eliminar pill',
        eliminarConfirm: '¿Eliminar este acceso rápido del rail?',
        errorCargar: 'No se pudieron cargar los accesos rápidos.',
        errorGuardar: 'No se pudo guardar el acceso rápido.',
        errorEliminar: 'No se pudo eliminar el acceso rápido.',
      },
      corp: {
        firstLogin: 'Primer login',
        versionEs: 'Versión ES',
        versionEn: 'Versión EN',
        subirVersion: 'Subir',
        reemplazar: 'Reemplazar',
        verVersion: 'Ver versión',
        quitarVersion: 'Quitar versión',
        triggerUpdate: 'Detonar actualiz.',
        ousActivas: 'OUs activas',
        nombre: 'Nombre del documento',
        tipo: 'Tipo',
        visibilidad: 'Visibilidad por OU',
        idiomas: 'Idiomas',
        idiomasHint: 'Sin selección = todos los idiomas.',
        versionesPorIdioma: 'Versiones por idioma',
        versionesPorIdiomaCount: 'Versiones ({{count}}/{{total}})',
        archivo: 'Archivo PDF',
        elegirArchivo: 'Elegir PDF…',
        subir: 'Subir documento',
        agregarDocumento: 'Agregar Documento',
        subirArchivo: 'Subir Archivo',
        libType: { todos: 'Todos', pdf: 'PDF', video: 'Video', imagen: 'Imagen' },
        filterType: 'Tipo',
        nombreArchivo: 'Nombre del archivo',
        idioma: 'Idioma',
        pillAsignado: 'Pill asignado',
        subido: 'Subido',
        documento: 'Documento',
        actualizado: 'Actualizado',
        mediaKind: 'Tipo de archivo',
        externalUrl: 'URL externa',
        externalUrlHint: 'Pega el enlace del video o de la imagen (Teams, SharePoint, etc.).',
        requiereUrl: 'Ingresa una URL externa válida.',
        abrir: 'Abrir',
        dropMain: 'Arrastra archivos aquí o haz clic para cargar',
        dropSub: 'PDF · Máx. 25 MB por archivo',
        subidoOk: 'Documento subido.',
        errorSubir: 'No se pudo subir el documento.',
        lista: 'Documentos cargados',
        listaCount: '{{count}} documentos configurados',
        legalInfo: 'Estos documentos se muestran en el modal de aceptación obligatorio. Primer login los activa en el primer acceso. Detonar actualización vuelve a mostrarlos aunque el usuario ya los haya aceptado. Es necesaria aceptación explícita para continuar.',
        searchPlaceholder: 'Buscar archivo…',
        filterLang: 'Filtrar por idioma',
        filterLangAll: 'Todos los idiomas',
        noResults: 'Sin documentos que coincidan con el filtro.',
        vacio: 'Aún no hay documentos corporativos.',
        fecha: 'Fecha',
        acciones: 'Acciones',
        descargar: 'Descargar',
        editar: 'Editar',
        eliminar: 'Eliminar',
        guardar: 'Guardar cambios',
        cancelar: 'Cancelar',
        eliminarConfirm: '¿Eliminar este documento del repositorio?',
        errorEliminar: 'No se pudo eliminar el documento.',
        errorActualizar: 'No se pudo actualizar el documento.',
        errorCargar: 'No se pudo cargar la lista.',
        soloPdf: 'Solo se admite PDF de hasta 25 MB.',
        requiereNombre: 'Escribe un nombre.',
        requiereOu: 'Selecciona al menos una OU.',
        requiereArchivo: 'Elige un archivo PDF.',
        tipos: {
          PoliticaPrivacidad: 'Política de Privacidad',
          BasesLegales: 'Bases Legales',
          GuiaUsuario: 'Guía de Usuario',
          Premios: 'Premios',
          CookiesPolicy: 'Política de Cookies',
          LegalNotice: 'Aviso Legal',
        },
      },
      currentVersion: 'Versión vigente',
      noVersionYet: 'Aún no se ha publicado ninguna versión',
      newVersionLabel: 'Nueva versión a publicar',
      loadError: 'No se pudo cargar el borrador.',
      titleLabel: 'Título',
      sectionHeading: 'Encabezado',
      sectionBody: 'Cuerpo',
      addSection: 'Agregar sección',
      removeSection: 'Quitar sección',
      saveDraft: 'Guardar borrador',
      publish: 'Publicar',
      publishConfirm: 'Vas a publicar una versión nueva. Todos los usuarios deberán volver a aceptarla antes de poder reconocer. ¿Continuar?',
      missingLanguages: 'Faltan idiomas: {{languages}}',
      draftSaved: 'Borrador guardado',
      published: 'Versión publicada',
      saveError: 'No se pudo guardar el borrador.',
      publishError: 'No se pudo publicar la versión.',
    },
    recap: {
      title: 'Recap Anual',
      desc: 'Configura la experiencia Recap por edición. Los fondos y los iconos son configurables por slide; los datos del usuario (reconocimientos, Fundamental más recibido, fan #1, racha) se inyectan automáticamente desde la plataforma.',
      deniedRole: 'La gestión del Recap está reservada al Admin General y al Admin Fundamentales.',
      fixValidation: 'Completa los textos obligatorios antes de guardar.',
      noEditions: 'Todavía no hay ediciones del Recap.',
      createFirst: 'Crear la primera edición',
      edition: 'Edición',
      editionName: 'Nombre visible para el usuario',
      newEdition: 'Nueva edición',
      scope: 'Alcance OU',
      scopeGlobal: 'Global (todas)',
      active: 'Recap activo',
      activeOn: 'Activo',
      activeOff: 'Inactivo',
      visibleFrom: 'Inicio de visibilidad',
      visibleTo: 'Fin de visibilidad',
      notification: 'Notificación',
      notifiedAt: 'Enviada {{date}}',
      neverNotified: 'Sin notificar',
      difusionLockHint: 'Este Recap ya se difundió. Puedes AMPLIAR el alcance y la ventana de visibilidad, pero no reducirlos: quitar una OU o acortar las fechas dejaría fuera a gente a la que ya se le avisó. El resto de la edición se sigue editando con normalidad.',
      slidesTitle: 'Configuración de slides ({{count}} slides)',
      slidesHint: 'Los iconos de Fundamentales y los datos del usuario se inyectan automáticamente. Aquí configuras solo la capa visual y los textos.',
      i18nHint: 'Multiidioma: el título de cada slide se captura en los 7 idiomas desde el botón Editar.',
      colSlide: 'Slide',
      colPreview: 'Vista previa',
      colTitle: 'Título',
      colActive: 'Activo',
      colActions: 'Acciones',
      edit: 'Editar',
      titleMissing: 'Sin título',
      needAllLangs: 'Faltan idiomas por capturar (se requieren los 7).',
      slides: {
        portada:    { name: 'Portada',                 hint: 'Pantalla de bienvenida' },
        numeros:    { name: 'Tu año en números',       hint: 'Recibidos + enviados' },
        define:     { name: 'Lo que te define',        hint: 'Fundamental más recibido (dato automático)' },
        mensaje:    { name: 'El mensaje',              hint: 'Reconocimiento más largo (dato automático)' },
        quienes:    { name: 'Quiénes te reconocieron', hint: 'Totales y personas (dato automático)' },
        red:        { name: 'Tu red',                  hint: 'Áreas distintas que te reconocieron (dato automático)' },
        constancia: { name: 'Tu constancia',           hint: 'Racha de semanas (dato automático)' },
        reto:       { name: 'Tu reto del año próximo', hint: 'Fundamental menos mostrado y llamado a la acción' },
        ganador:    { name: 'Ganador Anual',           hint: 'Si el usuario fue ganador: insignia real de la sección Ganadores' },
      },
      notifyTitle: 'Notificación del Recap',
      notifyDesc: 'Avisa a los colaboradores del alcance seleccionado que su Recap {{year}} ya está listo.',
      preview: 'Vista previa',
      send: 'Enviar notificación',
      notifyNeedsActive: 'Activa la edición para poder notificarla.',
      notifyError: 'No se pudo enviar la notificación.',
      previewNote: 'Así se recorre la edición: solo los slides activos, con sus fondos y títulos. Los números son del usuario que la abra.',
      genericTitle: 'Mensaje genérico (respaldo)',
      genericDesc: 'Se muestra cuando el usuario no tiene reconocimientos en el periodo o cuando entra antes de que el Recap esté visible.',
      genericTitleLabel: 'Título del mensaje genérico',
      genericDescLabel: 'Subtítulo / descripción',
      genericNote: 'Este mensaje es el respaldo: quien tenga datos verá su Recap personalizado.',
      imageUrlPlaceholder: 'URL de la imagen (PNG / JPG)',
      historyTitle: 'Historial de Recap y ganadores anuales',
      historyDesc: 'Ediciones registradas y los ganadores anuales asociados a cada una.',
      colEdition: 'Edición',
      colYear: 'Año',
      colScope: 'Alcance',
      colSlides: 'Slides',
      colWinners: 'Ganadores anuales',
      colStatus: 'Estado',
      winnersCount: '{{count}} ganadores',
      status: { activa: 'Activa', completada: 'Completada', borrador: 'Borrador' },
      editorTitle: 'Editar slide {{index}}',
      editorDescData: 'Configura el título (7 idiomas), el fondo y el texto que acompaña al dato dinámico. La vista previa se actualiza mientras escribes.',
      editorDescIcon: 'Configura el título (7 idiomas), el fondo y el icono del slide. La vista previa se actualiza mientras escribes.',
      titleLangs: 'Título (7 idiomas)',
      titlePlaceholder: 'Título en {{lang}}',
      autoIcon: 'El icono de este slide es automático: usa la insignia real del ganador configurada en Ganadores.',
      icon: 'Icono',
      iconPlaceholder: 'Emoji o URL de imagen',
      numberLabels: 'Texto bajo los números',
      numberLabelsHint: 'Los números los calcula la plataforma; aquí defines la palabra que va debajo.',
      numberLabelPlaceholder: 'Ej.: recibidos',
      background: 'Fondo',
      previewLabel: 'Vista previa',
      previewDataNote: 'Los números mostrados son del usuario que abre su Recap.',
      apply: 'Aplicar',
    },
  },
  // ── WP-16 REQ-140 — Modales legales ──
  legal: {
    privacy: 'Política de Privacidad',
    legal: 'Bases Legales del Programa',
    reachedEnd: '¡Has llegado al final!',
    scrollHint: 'Desplázate hasta el final para aceptar',
    accept: 'Acepto',
    acceptError: 'No se pudo registrar tu aceptación.',
    loadError: 'No se pudo cargar el documento.',
    pdfError: 'No se pudo mostrar el documento en PDF.',
    retry: 'Reintentar',
    openInNewTab: 'Abrir en pestaña nueva',
  },
  // ── WP-16 REQ-139 — Registro standalone Frontline ──
  register: {
    backToLogin: '← Volver al inicio de sesión',
    entraTitle: '¿Ya tienes correo institucional?',
    entraSub: 'No necesitas registrarte — entra directo con tu cuenta Sigma.',
    title: 'Registro',
    subtitle: 'Crea tu acceso al Programa de Reconocimiento.',
    fullName: 'Nombre completo',
    email: 'Correo electrónico',
    ou: 'Unidad organizativa',
    selectOu: 'Selecciona tu OU',
    startDate: 'Fecha de ingreso a Sigma',
    employeeId: 'Número de nómina',
    bu: 'Unidad de negocio',
    site: 'Centro de trabajo',
    department: 'Departamento',
    selectBu: 'Selecciona tu Unidad de Negocio',
    selectSite: 'Selecciona tu centro de trabajo',
    selectDepartment: 'Selecciona tu departamento',
    errName: 'Introduce tu nombre completo.',
    errEmail: 'Introduce un correo electrónico válido.',
    errOu: 'Selecciona tu OU.',
    errCatalogs: 'Completa unidad de negocio, centro y departamento.',
    errStartDate: 'Introduce tu fecha de ingreso.',
    errEmployeeId: 'Introduce tu número de nómina.',
    catalogsError: 'No se pudieron cargar los catálogos.',
    submit: 'Registrarme',
    submitError: 'No se pudo completar el registro.',
    checkEmailTitle: 'Revisa tu correo',
    checkEmailSub: 'Enviamos un enlace de verificación a {{email}}.',
    verifyFailed: 'No se pudo verificar tu correo. El enlace puede haber expirado.',
    verified: 'Correo verificado',
    allSet: '¡Todo listo!',
    allSetSub: 'Tu cuenta quedó configurada. Ya puedes reconocer a tus compañeros.',
    password: 'Contraseña (mín. 8 caracteres)',
    confirmPassword: 'Confirmar contraseña',
    errPassword: 'La contraseña debe tener al menos 8 caracteres.',
    errPasswordMatch: 'Las contraseñas no coinciden.',
    errLegal: 'Debes aceptar las Bases Legales.',
    errLegalVersion: 'No se pudo cargar el documento legal. Vuelve a intentarlo.',
    errPrivacy: 'Debes aceptar el Aviso de Privacidad.',
    errLocalId: 'Introduce tu Local ID (hasta 8 dígitos).',
    errDepartment: 'Selecciona tu departamento.',
    acceptPrivacy: 'He leído y acepto el',
    acceptLegalBases: 'He leído y acepto las',
    privacyLink: 'Aviso de Privacidad',
    legalLink: 'Bases Legales',
    localId: 'Local ID',
    policyPlaceholder: 'Lee el documento completo. Al finalizar podrás aceptarlo.',
    createdTitle: 'Cuenta creada',
    createdSub: 'Ya puedes iniciar sesión con tu correo y contraseña. Al entrar podrás elegir tu avatar.',
    checkEmailHint: 'Abre el enlace para confirmar tu correo y poder iniciar sesión. Caduca en 72 horas.',
    resend: 'Reenviar el correo',
    resendDone: 'Si tu cuenta está pendiente de verificar, te enviamos otro enlace. Si ya la verificaste, entra con tu correo y contraseña.',
  },
  // ── Login (RF-002) ──
  login: {
    title: 'Iniciar sesión',
    subtitle: 'Programa de Reconocimiento',
    entraRouteTitle: 'Entra con tu correo institucional',
    entraRouteSub: 'Usa tu cuenta Sigma (Entra ID).',
    entra: 'Entra con correo Sigma',
    frontlineRouteTitle: '¿No tienes correo institucional?',
    frontlineRouteSub: 'Entra con tu correo y contraseña.',
    email: 'Correo',
    password: 'Contraseña',
    submit: 'Iniciar sesión',
    submitting: 'Ingresando…',
    or: 'o',
    toRegister: '¿No tienes cuenta? Regístrate',
    noAccountLede: '¿No tienes cuenta institucional?',
    noAccountSub: 'Ingresa un correo personal',
    alreadyRegisteredLede: '¿Ya te registraste?',
    hasInstitutionalEmailLede: '¿Tienes un correo institucional?',
    register: 'Regístrate',
    back: 'Volver',
    forgot: '¿Olvidaste tu contraseña?',
    forgotIntro: 'Escribe tu correo y te enviamos un enlace para crear una contraseña nueva.',
    forgotSubmit: 'Enviarme el enlace',
    forgotSent: 'Si ese correo está registrado, te enviamos un enlace. Caduca en 60 minutos.',
    resendVerification: '¿No recibiste el correo de verificación?',
    resendIntro: 'Escribe tu correo y te enviamos otro enlace de verificación.',
    resendSubmit: 'Reenviar el correo',
    resendSent: 'Si tu cuenta está pendiente de verificar, te enviamos otro enlace. Si ya la verificaste, entra con tu correo y contraseña.',
    errRequired: 'Ingresa tu correo y contraseña.',
    errCredentials: 'Correo o contraseña incorrectos.',
  },
  // ── Landing común (regla #3) ──
  landing: {
    question: '¿Qué fundamentales vamos a reconocer hoy?',
    subtitle: 'Elige un espacio para vivir tus fundamentales',
    cardPulso: 'Post Meeting Pulse',
    cardShine: 'Shine Together',
    pulsoHover: '¿Cómo estuvo tu equipo en la última junta? Cuéntales lo que viste 💬',
    shineHover: '¿Quieres ver quién está brillando y nominar a un compañero?',
  },
  // Restablecimiento de contrasena Frontline (/app/restablecer)
  reset: {
    title: 'Crea tu contraseña nueva',
    subtitle: 'Elige una contraseña para volver a entrar.',
    password: 'Contraseña nueva (mín. 8 caracteres)',
    confirmPassword: 'Confirmar contraseña',
    submit: 'Cambiar mi contraseña',
    errPassword: 'La contraseña debe tener al menos 8 caracteres.',
    errPasswordMatch: 'Las contraseñas no coinciden.',
    errInvalidLink: 'El enlace no es válido o ya expiró. Solicita uno nuevo desde el inicio de sesión.',
    doneTitle: 'Contraseña actualizada',
    doneSub: 'Ya puedes iniciar sesión con tu correo y tu contraseña nueva.',
    noToken: 'Enlace inválido',
    noTokenSub: 'El enlace no es válido o está incompleto. Revisa el correo que recibiste.',
  },
  auth: {
    retryIn: 'Puedes reintentar en {{seconds}} s',
    contactHR: 'Si tienes problemas para registrarte, contacta a tu equipo de Capital Humano.',
    errorTitle: 'No pudimos continuar',
  },
  // ── WP-16 REQ-141 — Avatar ──
  avatar: {
    title: 'Elige tu avatar',
    subtitle: 'Elige la imagen que te representa.',
    loading: 'Cargando avatares…',
    empty: 'Aún no hay avatares disponibles.',
    loadError: 'No se pudieron cargar los avatares.',
    saveError: 'No se pudo guardar tu avatar.',
    saved: 'Avatar guardado',
    confirm: 'Confirmar',
    required: 'Elige tu avatar para continuar.',
    unavailable: 'Ese avatar ya no está disponible. Elige otro.',
    change: 'Cambiar avatar',
    continueWithout: 'Continuar sin avatar',
  },
  // ── WP-08 — Reportería de Reconocimiento ──
  reports: {
    title: 'Reportería',
    subtitle: 'Analítica del Programa de Reconocimiento. Nunca muestra puntos.',
    emptyScope: 'No tienes ninguna OU asignada dentro de tu alcance.',
    tabs: {
      daily: 'Reco Diario',
      shine: 'Brillamos Juntos',
      history: 'Históricos',
      heatmap: 'Mapa de calor',
      network: 'Red ONA',
      generational: 'Demográfico',
      leaders: 'Líderes',
      moderation: 'Moderación',
      campaigns: 'Campañas General',
    },
    common: {
      loading: 'Cargando reportería…',
      error: 'No se pudo cargar el reporte.',
      empty: 'No hay datos para los filtros seleccionados.',
      retry: 'Reintentar',
      suppressedNote: 'Algunos agregados se ocultaron por el umbral de anonimato (menos de 5).',
      suppressedNoteHelp: 'Cuando en un grupo hay menos de 5 personas, sus métricas desagregadas no se publican: con tan pocas, el dato permitiría identificar a alguien por inferencia. No es un error ni falta de información.',
      colScope: 'Alcance (unidades)',
      colScopeHelp: 'Unidades organizativas a las que se dirigió la campaña.',
      colAudienceHelp: 'Número de empleados a quienes fue dirigida la campaña. Es el denominador de la tasa de participación.',
      scopeAll: 'Toda la organización',
      scopeMore: '+{{n}} más',
      masked: 'Oculto por anonimato',
      showingRange: 'Mostrando {{desde}}–{{hasta}} de {{total}}',
      pageSize: 'Filas por página',
      perPage: '{{n}} por pág.',
      exportExcel: 'Exportar a Excel',
      yes: 'Sí',
      no: 'No',
    },
    context: {
      unifiedTitle: 'Métricas unificadas',
      unifiedText: '— Reco Diario y Brillamos Juntos usan la misma lógica de conteo. Los datos son consistentes entre módulos.',
      auditTitle: 'Auditoría activa.',
      auditText: 'Cada descarga queda registrada con tu usuario, la pestaña y la fecha.',
      showing: 'Mostrando:',
      wholeOrg: 'toda la organización',
    },
    filters: {
      allFundamentals: 'Todos los Fundamentales',
      allOus: 'Todas las OUs',
      dateFrom: 'Desde',
      dateTo: 'Hasta',
      reset: 'Limpiar',
      ou: 'Unidad',
      fundamental: 'Fundamental',
      dateRange: 'Fechas',
      remove: 'Quitar filtro {{filter}}',
      person: 'Persona',
      personPlaceholder: 'Buscar persona…',
      personClear: 'Quitar la persona seleccionada',
      personNoResults: 'Sin coincidencias en el directorio',
      personSearching: 'Buscando…',
      personError: 'No se pudo consultar el directorio',
    },
    notApplicable: {
      title_one: 'El filtro {{filtros}} no aplica en esta sección.',
      // `title_few` — ninguna regla de plural cardinal de `Intl.PluralRules('es')` selecciona «few»
      // (categorías: one/many/other), pero la paridad de claves entre los 7 locales (prueba
      // `recognitionLocales.test.ts`) exige que todos compartan el mismo árbol: `ro` SÍ selecciona
      // «few» para 2 (sus únicos dos filtros posibles), así que la clave existe aquí como alias
      // inerte de `title_other`.
      title_few: 'Los filtros {{filtros}} no aplican en esta sección.',
      title_other: 'Los filtros {{filtros}} no aplican en esta sección.',
      and: 'y',
      reason: {
        embudo: 'El embudo reparte a toda la población entre Habituales, Ocasionales e Inactivos; acotado a una sola persona dejaría de ser un reparto.',
        historico: 'Estas cifras son de «alguna vez», no del periodo elegido: cuentan a quien ha reconocido en toda su historia en la plataforma.',
        audienciaCampana: 'Este indicador se calcula sobre la audiencia convocada por la campaña, que es la misma sin importar el Fundamental o la persona que se elija.',
        porBanda: 'La distribución agrupa a las personas por banda generacional; con una sola persona seleccionada quedaría una única banda y dejaría de ser una distribución.',
        porOu: 'Esta vista agrupa por unidad organizativa, no por persona.',
        redOu: 'Los nodos de la red son unidades organizativas, no personas.',
        promedioPulso: 'Esta tabla sale de las puntuaciones promedio de Pulso (1-4) por generación y Fundamental, no del conteo de reconocimientos ni del censo de plantilla: ninguno de los dos filtros la acota.',
        resumenCampana: 'Este indicador sale del resumen de la campaña completa: el backend no admite acotarlo a una sola persona (sí lo hace por Fundamental).',
        casosReportados: 'El reporte lista CASOS reportados, y el motivo del reporte lo escribe quien reporta: no está ligado a un Fundamental del reconocimiento. La OU, el rango de fechas y la persona sí acotan esta tabla.',
      },
    },
    daily: {
      title: 'Reconocimiento Diario',
      subtitle: 'Solo reconocimientos del día a día, sin campañas: periodo elegido vs. anterior, embudo de participación y tops.',
      // T-05 — el tab respeta el rango del filtro, así que la comparativa ya no es «semana»
      // fija: es el periodo elegido contra el anterior equivalente. Sin rango, sigue siendo
      // la semana en curso, que es el valor por omisión que pide la Especificación.
      thisPeriod: 'Periodo elegido',
      prevPeriod: 'Periodo anterior',
      vsPrev: '{{variacion}} vs. periodo anterior · {{previo}}',
      fundamentalDistribution: 'Distribución por Fundamental',
      totalSentTitle: 'Total de reconocimientos enviados',
      totalSentHint: 'Suma de todos los reconocimientos enviados en el periodo',
      retiredFundamental: 'Fundamental retirado',
      unresolvedFundamental: 'Fundamental (sin catálogo)',
      retiredFundamentalHint: 'Fundamental retirado del catálogo: se conserva en el histórico porque hubo reconocimientos con él, pero ya no puede elegirse.',
      adoptionStaff: 'Usuarios Staff',
      adoptionFrontline: 'Usuarios Frontline',
      adoptionTotal: 'Usuarios totales',
      noActivity: 'Sin actividad',
      adoptionHint: '{{reconocedores}} de {{plantilla}} han reconocido',
      adoptionTotalHint: '{{pct}} de la plantilla total ({{plantilla}})',
      noActivityHint: 'Nunca han enviado un reconocimiento',
      variation: 'Variación',
      sparkAria: 'Tendencia diaria de {{label}}: {{dias}} días, de {{primero}} a {{ultimo}}',
      uniquePeople: 'Personas únicas',
      pares: 'Pares',
      lideres: 'Líderes',
      funnel: 'Embudo de participación',
      funnelMonthSelector: 'Mes del embudo de participación',
      funnelRange: 'Rango: {{from}} – {{to}}',
      funnelPeople: '{{count}} personas',
      topPeople: 'Top personas reconocidas',
      topRecognizers: 'Top reconocedores',
      topFundamentals: 'Top fundamentales',
      // E6 — botón de export multi-hoja (7 hojas) del tab completo.
      exportMultiSheet: 'Exportar Diario (6 hojas)',
      colStage: 'Etapa',
      // C2 — las ocho columnas de los Top-10 de la maqueta.
      colName: "Nombre",
      colDepto: "Departamento",
      colOu: "OU",
      colFundamental: "Fundamental",
      colRecos: 'Reconocimientos',
      colEnviados: "Enviados",
      colCrossOu: "Cross-OU",
      colType: "Tipo",
      crossOu: {
        si: "Sí",
        no: "No",
        desconocido: "—",
      },
      // Las 4 columnas que el Excel comparte con «Brillamos Juntos» (`excelPlantillaTeal.ts`, el
      // mismo constructor arma las hojas de ranking de los dos reportes) y que la pantalla del
      // Diario no pinta.
      colEmail: 'Correo',
      colEmployeeId: 'Numero Nómina',
      colRecognitions: 'Reconocimientos',
      colDominantType: 'Tipo dominante',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Reconocimiento Diario (`dailyExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `01 - Reconocimiento Diario.xlsx`
      // (auditoría 2026-09-05): nombres de hoja, banners, metadatos, encabezados de tabla y el
      // glosario completo de «Definiciones». El libro entero sale en el idioma de quien descarga.
      //
      // Las etiquetas de dato que la pantalla ya usa (`adoptionStaff`, `uniquePeople`, `colName`…)
      // NO se repiten aquí: se reusan de arriba para que la celda del Excel y la columna de la
      // tabla digan lo mismo.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Resumen Ejecutivo',
        sheetDefinitions: 'Definiciones',
        sheetFunnel: 'Embudo Adopción',
        sheetTopRecognized: 'Top Reconocidos',
        sheetTopRecognizers: 'Top Reconocedores',
        sheetAllRecognitions: 'Todos los reconocimientos',
        summaryTitle: 'Reconocimiento Diario — Fundamentales del día a día',
        summarySubtitle: 'Indicadores del periodo seleccionado: quién reconoce, a quién y con qué frecuencia.',
        definitionsTitle: '¿Qué significa cada dato?',
        definitionsSubtitle: 'Explicación en lenguaje simple, para cualquier persona que descargue este archivo, sin necesidad de saber de datos.',
        funnelTitle: 'Embudo de Adopción',
        funnelSubtitle: 'Segmentación calculada por frecuencia de reconocimientos enviados en el mes del embudo ({{rango}}).',
        funnelEmpty: 'Sin datos: no hay reconocimientos en el mes del embudo.',
        topRecognizedTitle: 'Top más reconocidos',
        topRecognizersTitle: 'Top reconocedores',
        rankingSubtitle: 'Ranking calculado por los reconocimientos del periodo.',
        topRecognizersEmpty: 'Sin datos: nadie ha reconocido en el periodo.',
        allRecognitionsTitle: 'Todos los reconocimientos',
        allRecognitionsSubtitle: 'Detalle crudo del día a día en el periodo, sin los envíos de campaña: una fila por candidato reconocido. Los nombres de columna se conservan en su forma original para que las tablas dinámicas del comité sigan funcionando.',
        allRecognitionsNoRange: 'Sin datos: no se pudo determinar el rango exacto del periodo, porque el agregado está suprimido por el umbral de anonimato y el filtro no trae fechas explícitas.',
        metaPeriod: 'Periodo',
        metaFilters: 'Filtros aplicados',
        metaFunnelMonth: 'Mes del embudo',
        metaGenerated: 'Generado',
        colKpi: 'KPI',
        colValue: 'Valor',
        colDetail: 'Detalle',
        colDatum: 'Dato',
        colWhatIs: 'Qué es',
        colHowCalculated: 'Cómo se calcula',
        colPercentOfTotal: '% del total',
        colSegment: 'Segmento',
        colPeople: 'Personas',
        colAdministrative: 'Administrativos',
        colOperational: 'Operativos',
        colFundamental: 'Fundamental',
        colRank: '#',
        colArea: 'Área',
        colSite: 'Site',
        headcountTitle: 'Plantilla',
        headcountTotal: 'Total',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Personas',
        kpiPeers: 'Pares (reconocimientos únicos entre pares)',
        kpiLeaders: 'Líderes (reconocimientos únicos donde participa un líder)',
        datumTeamRecognitions: 'Reconocimientos realizados a equipos',
        datumAudienceStaff: 'Audiencia Staff (administrativos)',
        datumAudienceFrontline: 'Audiencia Frontline (operativos)',
        datumComparison: 'Periodo anterior y variación',
        datumRankings: 'Top Reconocidos / Top Reconocedores',
        datumLeader: 'Líder',
        datumTruncated: 'Todos los reconocimientos — truncado',
        whatRecognitionsMade: 'Cuántos reconocimientos se enviaron en total durante el periodo, con los filtros aplicados.',
        calcRecognitionsMade: 'Se suman los reconocimientos del día a día con fecha dentro del periodo elegido. Los que pertenecen a una campaña se cuentan en el reporte de Brillamos Juntos.',
        whatUniqueRecognized: 'Cuántas personas distintas recibieron al menos un reconocimiento. Quien recibió cinco cuenta una sola vez.',
        calcUniqueRecognized: 'Se cuentan las personas diferentes que aparecen como receptoras en el periodo.',
        whatTeamRecognitions: 'Un reconocimiento es grupal cuando tiene más de un destinatario.',
        calcTeamRecognitions: 'La columna «Recognition type» de la hoja «Todos los reconocimientos» marca cada fila como Individual o Grupal.',
        whatPeers: 'Reconocimientos donde ni quien reconoce ni quien recibe tiene gente a su cargo: colaborador a colaborador, líder a líder, gerente a gerente.',
        calcPeers: 'Se filtran los reconocimientos entre pares dentro del periodo.',
        whatLeaders: 'Reconocimientos donde participa al menos una persona con gente a su cargo.',
        calcLeaders: 'Se filtran los reconocimientos donde quien emite o quien recibe tiene rol de líder, supervisor o gerente.',
        whatStaffAdoption: 'De todas las personas de oficina (Staff), qué porcentaje ya reconoció a alguien en el periodo.',
        calcStaffAdoption: 'Personas Staff con al menos un reconocimiento enviado en el periodo, dividido entre el total de personas Staff del alcance.',
        whatFrontlineAdoption: 'De todas las personas de operación o planta (Frontline), qué porcentaje ya reconoció a alguien en el periodo.',
        calcFrontlineAdoption: 'Personas Frontline con al menos un reconocimiento enviado en el periodo, dividido entre el total de personas Frontline del alcance.',
        whatTotalUsers: 'Cuántas personas del alcance han enviado al menos un reconocimiento alguna vez, desde que tienen cuenta.',
        calcTotalUsers: 'Personas con al menos un reconocimiento enviado en toda su historia. No depende del periodo seleccionado: sale del censo diario.',
        whatNoActivity: 'Personas que nunca han enviado un solo reconocimiento desde que tienen cuenta.',
        calcNoActivity: 'Plantilla total del alcance menos las personas con al menos un reconocimiento enviado en toda su historia.',
        whatAudienceStaff: 'Personas con cuenta corporativa de Entra ID.',
        whatAudienceFrontline: 'Personas que se registran en la plataforma con su propio correo.',
        whatPrevPeriod: 'Reconocimientos enviados en los mismos días inmediatamente antes del periodo seleccionado.',
        whatVariation: 'Cuánto creció o cayó el volumen de reconocimientos frente al periodo anterior equivalente.',
        calcVariation: 'El periodo anterior son los mismos días inmediatamente antes del seleccionado. La variación es la diferencia entre ambos, dividida entre el total del periodo anterior.',
        whatFunnel: 'Segmenta al alcance por frecuencia dentro del mes del embudo, una ventana propia e independiente del periodo de arriba: Habituales (cuatro o más al mes), Ocasionales (de uno a tres) e Inactivos (ninguno). Cada etapa se desglosa en Administrativos y Operativos.',
        calcFunnel: 'El porcentaje y la columna Personas se calculan sobre la plantilla del alcance. Administrativos y Operativos cuentan a esas mismas personas por tipo de puesto y quedan en blanco si esa clasificación no está disponible.',
        whatRankings: 'Las personas más reconocidas y quienes más reconocen en el periodo, hasta 200 en cada lista.',
        calcRankings: 'Se ordena por número de reconocimientos recibidos o enviados. Quien no alcanza el umbral de anonimato sale enmascarado.',
        whatAllRecognitions: 'Detalle crudo del periodo, una fila por candidato: los bloques Nominee, OnBehalfOf y Candidate completos, la fecha, la matriz de Hábitos activos y los indicadores de auditoría. No enmascara personas: es la fuente de trabajo del comité, y el umbral de anonimato aplica a los reportes agregados. Incluye los reconocimientos de campañas Brillamos Juntos vigentes, porque el Diario los cuenta todos.',
        calcAllRecognitions: 'Listado completo de los reconocimientos del periodo, hasta un máximo de 5000 filas. Las columnas de Hábitos solo incluyen los activos en el catálogo al momento de exportar. La columna Reco_ID queda vacía porque el sistema todavía no genera un identificador único por fila.',
        whatTruncated: 'Esta descarga se cortó en el tope de 5000 filas: el periodo tiene más reconocimientos de los que trae el archivo.',
        calcTruncated: 'Se alcanzó el tope antes de recorrer todas las páginas, así que el archivo está incompleto. Acota el periodo y vuelve a exportar.',
        noteLeader: 'Un rol se considera líder cuando tiene reportes a su cargo.',
        masked: 'Oculto por anonimato',
      },
    },
    shine: {
      title: 'Brillamos Juntos',
      subtitle: 'Ranking de nominaciones de la campaña y KPIs en vivo.',
      recognitionsMade: 'Reconocimientos realizados',
      uniqueRecognized: 'Personas únicas reconocidas',
      uniqueRecognizers: 'Personas únicas que reconocen',
      participationRate: 'Tasa de participación',
      totalHeadcount: 'Número total de plantilla',
      // E6 — reemplaza al export de una sola hoja: ahora arma las 7 hojas del Excel de Brillamos.
      exportMultiSheet: 'Exportar Brillamos (7 hojas)',
      // Fix round 1 (Tarea 17) — estado de carga/error del export, mismo criterio de texto que
      // `admin.winners.exporting`/`exportError`.
      exporting: 'Exportando…',
      exportError: 'No se pudo completar la descarga. Vuelve a intentarlo.',
      winnersFormat: 'Formato del export de ganadores',
      formatRaw: 'Crudo',
      formatCascaded: 'Cascadeado',
      exportWinners: 'Exportar ganadores',
      colPos: 'Posición',
      kpiTotal: 'Total',
      kpiParticipants: 'Participantes',
      kpiParticipation: 'Participación',
      kpiAvgPerPerson: 'Promedio por persona',
      // T-10 — el tab es POR CAMPAÑA (confirmado con Adriana, 18-ago-2026): sin una elegida
      // los indicadores no pueden acotarse y se pide elegir, en vez de pintar los del scope.
      campaignSelector: 'Campaña',
      modalidadSelector: 'Filtro Brillamos',
      daysLeft: 'Días restantes',
      activeOus: 'OUs activas',
      modalidadTodos: 'Todos los nominados',
      modalidadPersonaUnica: 'Solo persona única',
      modalidadCrossOu: 'Cross-OU',
      pickCampaign: 'Elige una campaña para ver sus indicadores y su ranking.',
      habitsRanking: 'Ranking de Daily Habits',
      colHabit: 'Daily Habit',
      colRecognitions: 'Reconocimientos',
      colName: 'Nombre',
      colBu: 'BU',
      colDept: 'Depto',
      colOrigin: 'Origen',
      filterHabitsByFundamental: 'Filtrar hábitos por Fundamental',
      allFundamentals: 'Todos los Fundamentales',
      colCount: 'Reconocimientos',
      colOu: 'OU',
      colCountry: 'País',
      colBadge: 'Insignia',
      colCrossed: 'Origen cruzado',
      // Tarea 16 — las 6 columnas nuevas de "Top Reconocidos"/"Top Reconocedores" (11 columnas
      // exactas de la plantilla real del cliente). `colName`/`colOu`/`colCount` ya existían arriba
      // y se reusan; `colFundamental` reusa `reports.daily.colFundamental` (mismo dato, no se
      // duplica la clave). `colCrossOu` reusa la misma traducción que ya usa `reports.daily`
      // para el mismo dato (Tabla de Top-10 del tab Diario). El departamento y el site NO tienen
      // clave aquí: el Excel de estas dos tablas escribe sus encabezados literales en español
      // (`buildEnrichedRankingSheet`), así que las claves que existían no se leían nunca.
      colEmail: 'Correo',
      colEmployeeId: 'Numero Nómina',
      colCrossOu: 'Cross-OU',
      colDominantType: 'Tipo dominante',
      // Fix round 1 (Tarea 14) — reubicadas desde un bloque `shine` de nivel superior huérfano
      // (nunca se leía: el tab completo usa `reports.shine.*`), que quedaba fuera de `reports` y
      // duplicaba estas mismas 10 claves con el contenido correcto. Sin esto, `tarjetasDeAdopcion`
      // y el banner de filtros aplicados pintaban la clave cruda en vez del texto traducido.
      adoptionStaff: 'Usuarios Staff',
      adoptionFrontline: 'Usuarios Frontline',
      adoptionTotal: 'Usuarios totales',
      noActivity: 'Sin actividad',
      adoptionHint: '{{reconocedores}} de {{plantilla}} han nominado',
      adoptionTotalHint: '{{pct}} de la plantilla total ({{plantilla}})',
      noActivityHint: 'Nunca han enviado una nominación',
      appliedFilters: 'Filtros aplicados:',
      appliedFiltersValue: 'Heredados del panel superior · Campañas activas',
      clearAll: 'Limpiar todo',
      // ───────────────────────────────────────────────────────────────────────────
      // Excel de Brillamos Juntos (`brillamosExcel.ts`) — textos EXCLUSIVOS del archivo
      // descargable, calcado de la plantilla del cliente `02 - Campana brillamos juntos.xlsx`
      // (auditoría 2026-09-05): nombres de hoja, banners, metadatos, encabezados de tabla y el
      // glosario completo de «Definiciones». El libro entero sale en el idioma de quien descarga.
      //
      // Las etiquetas de dato que la pantalla ya usa (`recognitionsMade`, `uniqueRecognized`,
      // `adoptionStaff`, `colName`, `colEmail`…) NO se repiten aquí: se reusan de arriba para que
      // la celda del Excel y la columna de la tabla digan lo mismo.
      // ───────────────────────────────────────────────────────────────────────────
      excel: {
        sheetSummary: 'Resumen Ejecutivo',
        sheetDefinitions: 'Definiciones',
        sheetDistribution: 'Distribución Fundamental',
        sheetFunnel: 'Embudo Adopción',
        sheetTopRecognized: 'Top Reconocidos',
        sheetTopRecognizers: 'Top Reconocedores',
        sheetAllRecognitions: 'Todos los reconocimientos',
        summaryTitle: 'Campaña Brillamos Juntos',
        definitionsTitle: '¿Qué significa cada dato?',
        definitionsSubtitle: 'Explicación en lenguaje simple, para cualquier persona que descargue este archivo, sin necesidad de saber de datos.',
        distributionTitle: 'Distribución por Fundamental',
        distributionSubtitle: 'Participación calculada desde los reconocimientos de esta campaña.',
        distributionChart: 'Reconocimientos por Fundamental',
        distributionNote: 'Un reconocimiento puede llevar más de un Fundamental o más de un Hábito a la vez, y cada uno se cuenta por separado: las sumas de esta tabla pueden no coincidir con el total de la campaña ni con el conteo de su Fundamental.',
        distributionEmpty: 'Sin datos: la campaña no tiene reconocimientos con Fundamental registrado en el periodo.',
        funnelTitle: 'Embudo de Adopción',
        funnelSubtitle: 'Segmentación calculada por frecuencia de reconocimientos enviados en el periodo de la campaña.',
        funnelEmpty: 'Sin datos: la campaña no tiene reconocimientos en el periodo.',
        topRecognizedTitle: 'Top más reconocidos',
        topRecognizersTitle: 'Top reconocedores',
        rankingSubtitle: 'Ranking calculado por los reconocimientos de esta campaña.',
        topRecognizersEmpty: 'Sin datos: nadie ha reconocido dentro de esta campaña.',
        allRecognitionsTitle: 'Todos los reconocimientos',
        allRecognitionsSubtitle: 'Detalle crudo de la campaña: una fila por candidato reconocido. Los nombres de columna se conservan en su forma original para que las tablas dinámicas del comité sigan funcionando.',
        metaPeriod: 'Periodo',
        metaFilters: 'Filtros aplicados',
        metaGenerated: 'Generado',
        colKpi: 'KPI',
        colValue: 'Valor',
        colDetail: 'Detalle',
        colDatum: 'Dato',
        colWhatIs: 'Qué es',
        colHowCalculated: 'Cómo se calcula',
        colFundamentals: 'Fundamentales',
        colPercentOfTotal: '% del total',
        colSegment: 'Segmento',
        colPeople: 'Personas',
        colAdministrative: 'Administrativos',
        colOperational: 'Operativos',
        // El Fundamental de una fila del ranking. Clave propia y no la de `reports.daily`:
        // `brillamosExcel.ts` resuelve todo su texto bajo `reports.shine`.
        colFundamental: 'Fundamental',
        colRank: '#',
        colArea: 'Área',
        colSite: 'Site',
        headcountTitle: 'Plantilla',
        headcountTotal: 'Total',
        headcountStaff: 'Staff',
        headcountFrontline: 'Frontline',
        headcountPeople: 'Personas',
        kpiPeers: 'Pares (reconocimientos únicos entre pares)',
        kpiLeaders: 'Líderes (reconocimientos únicos donde participa un líder)',
        kpiTotalSent: 'Total de reconocimientos enviados',
        kpiIndividual: 'Total de reconocimientos a una sola persona',
        kpiGroup: 'Total de reconocimientos realizados a grupos',
        datumTeamRecognitions: 'Reconocimientos realizados a equipos',
        datumAudienceStaff: 'Audiencia Staff (administrativos)',
        datumAudienceFrontline: 'Audiencia Frontline (operativos)',
        datumLeader: 'Líder',
        datumTruncated: 'Todos los reconocimientos — truncado',
        whatRecognitionsMade: 'Cuántos reconocimientos se enviaron en total dentro de la campaña, con los filtros aplicados.',
        calcRecognitionsMade: 'Se suman todos los reconocimientos con fecha dentro del periodo de la campaña.',
        whatUniqueRecognized: 'Cuántas personas distintas recibieron al menos un reconocimiento. Quien recibió cinco cuenta una sola vez.',
        calcUniqueRecognized: 'Se cuentan las personas diferentes que aparecen como receptoras en el periodo.',
        whatTeamRecognitions: 'Un reconocimiento es grupal cuando tiene más de un destinatario.',
        calcTeamRecognitions: 'Se cuentan los reconocimientos con dos o más personas como destinatario.',
        whatIndividual: 'Reconocimientos de la campaña dirigidos a una sola persona.',
        calcIndividual: 'Se cuentan los reconocimientos con exactamente un destinatario.',
        whatPeers: 'Reconocimientos donde ni quien reconoce ni quien recibe tiene gente a su cargo: colaborador a colaborador, líder a líder, gerente a gerente.',
        calcPeers: 'Se filtran los reconocimientos entre pares dentro de esta campaña.',
        whatLeaders: 'Reconocimientos donde participa al menos una persona con gente a su cargo.',
        calcLeaders: 'Se filtran los reconocimientos donde quien emite o quien recibe tiene rol de líder, supervisor o gerente.',
        whatStaffAdoption: 'De todas las personas de oficina (Staff), qué porcentaje ya reconoció a alguien en esta campaña.',
        calcStaffAdoption: 'Personas Staff con al menos un reconocimiento enviado en la campaña, dividido entre el total de personas Staff de su audiencia.',
        whatFrontlineAdoption: 'De todas las personas de operación o planta (Frontline), qué porcentaje ya reconoció a alguien en esta campaña.',
        calcFrontlineAdoption: 'Personas Frontline con al menos un reconocimiento enviado en la campaña, dividido entre el total de personas Frontline de su audiencia.',
        whatTotalUsers: 'Cuántas personas de la audiencia de la campaña enviaron al menos un reconocimiento dentro de ella.',
        calcTotalUsers: 'Personas con al menos un reconocimiento enviado en el periodo de la campaña. No es un conteo histórico de toda la vida del usuario.',
        whatNoActivity: 'Personas de la audiencia que no enviaron ningún reconocimiento durante la campaña.',
        calcNoActivity: 'Audiencia de la campaña menos las personas con al menos un reconocimiento enviado en ella.',
        whatAudienceStaff: 'Personas con cuenta corporativa de Entra ID.',
        whatAudienceFrontline: 'Personas que se registran en la plataforma con su propio correo.',
        whatParticipationRate: 'Porcentaje de la audiencia objetivo que participó en la campaña, reconociendo o siendo reconocida.',
        calcParticipationRate: 'Participantes dividido entre la audiencia objetivo de la campaña.',
        whatUniqueRecognizers: 'Personas distintas que enviaron al menos un reconocimiento dentro de esta campaña.',
        calcUniqueRecognizers: 'Conteo de emisores distintos en los reconocimientos de la campaña.',
        whatDistribution: 'Jerarquía de dos niveles: cada Fundamental con su porcentaje sobre el total de la campaña y, debajo e indentados, sus Daily Habits con el porcentaje que representan dentro de ese Fundamental.',
        calcDistribution: 'El porcentaje del Fundamental es su número de reconocimientos entre el total de la campaña. El del Hábito es su número de reconocimientos entre el total de su Fundamental.',
        whatFunnel: 'Segmenta a la audiencia de la campaña por frecuencia: Habituales (cuatro o más al mes), Ocasionales (de uno a tres) e Inactivos (ninguno). Cada etapa se desglosa en Administrativos y Operativos.',
        calcFunnel: 'El porcentaje y la columna Personas se calculan sobre la audiencia de la campaña, no sobre toda la organización. Administrativos y Operativos cuentan a esas mismas personas por tipo de puesto y quedan en blanco si esa clasificación no está disponible.',
        whatAllRecognitions: 'Detalle crudo de la campaña, una fila por candidato: los bloques Nominee, OnBehalfOf y Candidate completos, la fecha, la matriz de Hábitos activos y los indicadores de auditoría. No enmascara personas: es la fuente de trabajo del comité, y el umbral de anonimato aplica a los reportes agregados.',
        calcAllRecognitions: 'Listado completo de los reconocimientos del periodo, hasta un máximo de 5000 filas. Las columnas de Hábitos solo incluyen los activos en el catálogo al momento de exportar. La columna Reco_ID queda vacía porque el sistema todavía no genera un identificador único por fila.',
        whatTruncated: 'Esta descarga se cortó en el tope de 5000 filas: la campaña tiene más reconocimientos de los que trae el archivo.',
        calcTruncated: 'Se alcanzó el tope antes de recorrer todas las páginas, así que el archivo está incompleto. Acota el periodo o la campaña y vuelve a exportar.',
        noteLeader: 'Un rol se considera líder cuando tiene reportes a su cargo.',
        masked: 'Oculto por anonimato',
        crossOuCount: '{{count}} OUs',
      },
    },
    history: {
      title: 'Históricos',
      subtitle: 'Histórico completo de una campaña: nombre y nominaciones recibidas.',
      selectCampaign: 'Elige una campaña',
      pickCampaign: 'Elige una campaña para ver su histórico.',
      search: 'Buscar por nombre…',
      colPos: 'Posición',
      colName: 'Nombre',
      colNominations: 'Nominaciones',
      // C2 — «Históricos por Campaña» (rep-panel-historicos).
      colCampaign: "Campaña",
        colType: "Tipo",
        colStatus: "Estado",
      colAudience: 'Audiencia (personas)',
        colRecognitions: "Reconocimientos",
      colOrigin: "Origen",
        colExpiration: "Expiración",
        colActions: "Acciones",
        status: {
        activo: "Activa",
          expirado: "Expirada",
          borrador: "Borrador",
        },
        origin: {
        original: "Original",
          local: "Local",
        },
      // P18-ter — reporte GLOBAL de campañas (todas, no una), calcado de 03 - Historicos.xlsx.
      kpiTotalCampaigns: 'Total de Campañas',
      kpiTotalRecognitions: 'Total de Reconocimientos',
      kpiAudienceTotal: 'Audiencia Total',
      kpiParticipantsTotal: 'Participantes',
      kpiParticipantsStaff: 'Participantes Staff',
      kpiParticipantsFrontline: 'Participantes Frontline',
      kpiParticipationRate: 'Porcentaje de Participación',
      kpiAvgPerParticipant: 'Promedio de reconocimientos por participante',
      colDescription: 'Descripción',
      colParticipants: 'Participantes',
      colParticipantsStaff: 'Participantes Staff',
      colParticipantsFrontline: 'Participantes Frontline',
      colDuration: 'Duración de la campaña',
      colFrequency: 'Frecuencia',
      colGoalPercent: '% de Meta',
      downloadGlobalExcel: 'Descargar reporte global',
      downloadGlobalError: 'No se pudo descargar el reporte global.',
      // Excel de Históricos (`historicosExcel.ts`) — textos EXCLUSIVOS del archivo descargable:
      // nombres de hoja, banner, metadatos y glosario. Las etiquetas de dato no se repiten aquí: se
      // reusan las claves `kpi*`/`col*` de arriba, que la pantalla también usa, para que la columna
      // del Excel y la de la tabla digan lo mismo.
      excel: {
        sheetSummary: 'Resumen Ejecutivo',
        sheetDefinitions: 'Definiciones',
        sheetCampaigns: 'Campañas Históricas',
        summaryTitle: 'Históricos por Campaña',
        summarySubtitle: 'Consolida el histórico de campañas de reconocimiento: audiencia, participación y volumen de reconocimientos de cada una.',
        campaignsSubtitle: 'Detalle comparativo por campaña.',
        definitionsTitle: '¿Qué significa cada dato?',
        definitionsSubtitle: 'Explicación en lenguaje simple, homologada con el Resumen Ejecutivo e incluyendo cómo se mide cada KPI.',
        metaFilter: 'Filtro aplicado',
        metaGenerated: 'Generado',
        filterAllCampaigns: 'Todas las campañas',
        colKpi: 'KPI',
        colValue: 'Valor',
        colNote: 'Nota / definición',
        colDatum: 'Dato',
        colWhatIs: 'Qué es',
        colHowMeasured: 'Cómo se mide',
        colHowCalculated: 'Cómo se calcula',
        colComparedTo: 'Se compara contra',
        colWhereShown: 'Dónde aparece',
        colAudienceOu: 'Audiencia OU',
        whereSummary: 'Resumen Ejecutivo',
        whereSummaryCampaigns: 'Resumen Ejecutivo / Campañas Históricas',
        datumStaffFrontline: 'Participantes Staff / Participantes Frontline',
        durationMonths_one: '{{count}} mes',
        durationMonths_few: '{{count}} meses',
        durationMonths_other: '{{count}} meses',
        whatCampaigns: 'Cantidad de campañas incluidas en el histórico o en el filtro aplicado.',
        measuredCampaigns: 'Se mide contando cada campaña registrada con nombre válido en la base histórica.',
        calcCampaigns: 'Conteo de campañas únicas incluidas en el alcance del reporte.',
        vsCampaigns: 'Contra el universo de campañas disponibles o contra cortes anteriores.',
        whatRecognitions: 'Reconocimientos acumulados dentro del alcance seleccionado.',
        measuredRecognitions: 'Se mide como cada reconocimiento registrado para las campañas incluidas.',
        calcRecognitions: 'Suma de todos los reconocimientos de las campañas filtradas.',
        vsRecognitions: 'Contra otras campañas, periodos anteriores o la meta definida.',
        whatAudience: 'Número de empleados a quienes fue dirigida la campaña.',
        measuredAudience: 'Se mide con la audiencia objetivo definida en la configuración de la campaña.',
        calcAudience: 'Total de empleados elegibles dentro de la OU, país, BU o alcance configurado.',
        vsAudience: 'Base para calcular la participación; 100% equivale a cubrir toda la audiencia.',
        whatParticipants: 'Personas distintas que participaron enviando al menos un reconocimiento.',
        measuredParticipants: 'Se mide contando personas únicas que enviaron al menos un reconocimiento.',
        calcParticipants: 'Conteo distinto de usuarios emisores con uno o más reconocimientos.',
        vsParticipants: 'Contra la Audiencia Total y contra campañas comparables.',
        whatStaffFrontline: 'De los participantes, cuántos son de oficina (Staff) y cuántos personal de planta (Frontline).',
        measuredStaffFrontline: 'Se resuelve el segmento vigente de cada persona al generar el reporte, no el que tenía al participar.',
        calcStaffFrontline: 'Conteo de participantes según el segmento registrado en su ficha del directorio.',
        vsStaffFrontline: 'Contra el total de Participantes de esa misma fila.',
        whatRate: 'Porcentaje de la audiencia objetivo que sí participó.',
        measuredRate: 'Se mide como la proporción de participantes sobre la audiencia total.',
        calcRate: 'Participantes ÷ Audiencia Total.',
        vsRate: 'Contra la meta de participación; 100% significa que toda la audiencia participó.',
        whatAvg: 'Promedio de reconocimientos generados por cada participante activo.',
        measuredAvg: 'Se mide entre las personas que enviaron al menos un reconocimiento.',
        calcAvg: 'Total de Reconocimientos ÷ Participantes.',
        vsAvg: 'Contra otras campañas o contra el promedio esperado por participante.',
      },
    },
    headcount: {
      notaPeriodo: 'Referencia del periodo: sobre esta plantilla se calculan los KPIs de arriba.',
      notaAdopcion: 'Es el denominador de la adopción: de esta plantilla, cuántas personas han nominado.',
      title: 'Plantilla',
      updatedOn: 'Plantilla actualizada: {{fecha}}',
      // Fase 7 (2026-09-11, pedido del cliente) — las 3 fuentes se muestran SEPARADAS, no colapsadas
      // a la más reciente: el título queda sin fecha y cada fuente lleva la suya debajo.
      updatedOnTitle: 'Plantilla actualizada',
      sourceLatam: 'LATAM: {{fecha}}',
      sourceEuropa: 'Europa: {{fecha}}',
      sourceUsa: 'USA: {{fecha}}',
      sinDato: 'Sin dato',
      hint: 'Última carga de usuarios registrados en la plataforma',
      total: 'Total personas',
      staff: 'Staff',
      frontline: 'Frontline',
    },
    heatmap: {
      title: 'Mapa de calor OU × Fundamental',
      subtitle: 'Volumen de reconocimientos por OU y Fundamental. La intensidad del color muestra la concentración relativa dentro de cada columna.',
      ou: 'Unidad organizativa',
      // C2 — la columna Total que la maqueta cierra en el mapa de calor.
      total: 'Total',
    },
    network: {
      title: 'Red ONA',
      subtitle: 'Flujo de reconocimiento entre unidades (colaboración cruzada).',
      ous: 'Unidades',
      flows: 'Flujos',
      legendCross: 'Flujo cross-OU',
      legendInternal: 'Flujo interno',
      legendNode: 'Unidad (tamaño = volumen)',
      // C2 — la tabla de flujos que pide la maqueta, en vez del grafo SVG.
      colFlow: 'Flujo (De → A)',
      colRecognitions: 'Reconocimientos',
      // C2/C4 (2026-08-13) — reemplaza a `colIntensity`: la spec descartó el % de Intensidad y lo
      // sustituyó por el Fundamental más reconocido de la relación (`OnaEdgeDto.fundamentalDominante`).
      colDominantFundamental: 'Volumen de reconocimientos',
      colDominantFundamentalHelp: 'El largo de la barra representa el volumen de reconocimientos del flujo; el color indica cuál Fundamental fue el más reconocido en él.',
    },
    // 2026-09-04 — hoja "Definiciones" del Excel Demográfico, calcada de la plantilla del cliente
    // (`04 - Demografico.xlsx`): banner, las 4 columnas del glosario y una definición por cada dato
    // que el archivo realmente trae. Vivían como literales en español dentro de
    // `DemograficoExportButton.tsx`, así que la hoja salía en español aunque el resto del libro
    // fuera en el idioma de quien descarga.
    definitions: {
      title: '¿Qué significa cada dato?',
      subtitle: 'Explicación en lenguaje simple para cualquier persona que descargue este archivo, sin necesidad de saber de datos.',
      colData: 'Dato',
      colWhat: 'Qué es',
      colHow: 'Cómo se calcula',
      colVs: 'Se compara contra',
      percentTotalWhat: 'Qué porción de toda la plantilla activa pertenece a cada generación.',
      percentTotalHow: 'Personas activas de esa generación, en todas las OU del alcance, entre la plantilla total activa con banda generacional conocida.',
      percentTotalVs: 'Las demás generaciones de la misma tabla.',
      gapWhat: 'Qué tanto vive una generación cada Fundamental, en una escala del 1 al 4, y qué tan lejos queda su Fundamental más bajo del más alto.',
      gapHow: 'Promedio por generación y Fundamental de las puntuaciones de Pulso; la Δ es el máximo menos el mínimo de la fila, a un decimal.',
      gapVs: 'Los demás Fundamentales de la misma generación.',
      heatmapWhat: 'Cuántos reconocimientos se dieron en cada unidad organizativa, desglosados por Fundamental.',
      heatmapHow: 'Conteo agrupado por OU y Fundamental; las celdas con menos de 5 reconocimientos se ocultan por anonimato.',
      heatmapVs: 'Las demás OU y Fundamentales de la misma tabla.',
      networkWhat: 'Cuántos reconocimientos fluyeron de una unidad organizativa a otra.',
      networkHow: 'Conteo de reconocimientos enviados de una OU a otra, ordenado de mayor a menor.',
      networkVs: 'Los demás flujos de la misma tabla.',
    },
    generational: {
      title: 'Distribución Generacional',
      subtitle: 'Reconocimientos agrupados por banda generacional.',
      filterBu: 'Filtrar por BU…',
      filterDepto: 'Filtrar por departamento…',
      filterSite: 'Filtrar por site…',
      roleAll: 'Todos',
      roleLeaders: 'Líderes',
      rolePeers: 'Pares',
      // Bug UAT (17-ago-2026) — estas cuatro claves vivían por error en `admin.moderation`, así
      // que `BrechaGeneracionalTable` pintaba la clave cruda («reports.generational.gapTitle»).
      // Su sitio es este bloque: las consume el tab Demográfico, no la bandeja de moderación.
      gapTitle: 'Brecha Generacional × Fundamental',
      gapSubtitle: 'Puntuación promedio (1–4) por generación y Fundamental. Δ Brecha ≥ 1.0 = crítica.',
      // Task 3 (2026-09-01) — Δ Brecha se calcula sobre el valor SIN redondear de cada celda, pero
      // la celda se muestra redondeada a 1 decimal: con valores muy cercanos entre sí (ej. Millennial
      // 3.1311/3.0179/3.0357/2.9821 → celdas "3.1"/"3.0"/"3.0"/"3.0") la Δ visible no coincide con la
      // resta a ojo de las columnas redondeadas. No es un bug de cálculo, pero necesitaba explicación.
      gapTitleHelp: 'Cada celda se redondea a 1 decimal para la vista. Δ Brecha se calcula sobre el valor completo (sin redondear) de máximo menos mínimo de la fila, por eso puede no coincidir con la resta visual de las columnas redondeadas.',
      colGeneration: 'Generación',
      colGap: 'Δ Brecha',
      // C5/C7 (2026-08-13) — marcado visual de `ousConCobertura`: qué unidades tuvieron cobertura
      // de fecha de nacimiento suficiente para aportar al cálculo generacional.
      // T-11 — tarjetas de la maqueta: conteo de personas por banda y marca de la mayoritaria.
      people_one: '{{count}} persona',
      people_other: '{{count}} personas',
      majority: 'mayoría',
      coverageTitle: 'Unidades con cobertura de datos generacionales',
      // C7 — botón de export consolidado (6 hojas) del panel Demográfico completo.
      exportConsolidated: 'Exportar panel Demográfico (5 hojas)',
      // Task 9 — etiquetas de columna para la hoja de export de distribución generacional.
      // 2026-09-03 — encabezado de la hoja "Resumen Ejecutivo" del Excel Demográfico
      // (subtítulo + bloque de metadatos), según la plantilla de referencia del cliente.
      exportSubtitle: 'Composición de la plantilla por generación, OU y tipo de colaborador',
      metaPeriod: 'Periodo',
      metaFilters: 'Filtros aplicados',
      metaGenerated: 'Generado',
      colPercentTotal: '% del total',
      colYearRange: 'Rango de años',
      colPeople: 'Personas',
      colFrontline: 'Frontline',
      colStaff: 'Staff',
      colNote: 'Nota',
      // Valores de la columna «Nota» del Resumen Ejecutivo. Los emite
      // `buildGenerationalDistributionMatrix` como identificador canónico, no como texto,
      // justamente para poder traducirlos aquí.
      noteMajority: 'Mayoría',
      noteSmallSample: 'Muestra pequeña',
    },
    leaders: {
      title: 'Líderes',
      subtitle: 'Tamaño de equipo directo y reconocimientos por líder.',
      export: 'Exportar a Excel',
      colLeader: 'Líder',
      colPosition: 'Puesto',
      colOu: 'OU',
      colLevel: 'Nivel',
      colTeamSize: 'Tamaño de equipo',
      colTeamReceived: 'Reconocimientos del equipo (recibidos)',
      colTeamReceivedHelp: 'Total de reconocimientos recibidos por personas dentro de las estructuras de líderes.',
      colTeamSent: 'Reconocimientos del equipo (enviados)',
      colTeamSentHelp: 'Total de reconocimientos enviados por personas dentro de las estructuras de líderes.',
      colLeaderSent: 'Reconocimientos que envía el líder',
      colLeaderReceived: 'Reconocimientos que recibe el líder',
      colParticipation: 'Participación',
      colRatio: 'Ratio',
      colExport: 'Exportar',
      exportRow: 'Exportar esta fila',
      exportRowFor: 'Exportar la fila de {{name}}',
      kpiTotalLeaders: 'Total de líderes',
      kpiTeamSizeSum: 'Tamaño de equipo total',
      kpiRatioAvg: 'Ratio promedio',
      kpiParticipationAvg: 'Participación promedio',
      emptyByPerson: 'La persona seleccionada no aparece en ningún equipo dentro de tu alcance. Quita el filtro de persona para ver la tabla completa.',
      // Textos del Excel de Líderes (`leadersExcel.ts`): nombres de hoja, banner, bloque de
      // metadatos, encabezados de las hojas Resumen/Definiciones, el «Detalle» de cada KPI y el
      // glosario completo. Las etiquetas de dato NO se repiten aquí: se reusan de `col*`/`kpi*`
      // de arriba, que son las mismas que ya se leen en pantalla.
      excel: {
        sheetSummary: 'Resumen Ejecutivo',
        sheetDefinitions: 'Definiciones',
        sheetTeams: 'Equipos por líder',
        teamsSubtitle: 'Detalle de reconocimiento por estructura jerárquica.',
        definitionsTitle: '¿Qué significa cada dato?',
        definitionsSubtitle: 'Explicación en lenguaje simple, para cualquier persona que descargue este archivo — sin necesidad de saber de datos.',
        metaPeriod: 'Periodo',
        metaFilters: 'Filtros aplicados',
        metaGenerated: 'Generado',
        colKpi: 'KPI',
        colValue: 'Valor',
        colDetail: 'Detalle',
        colDatum: 'Dato',
        colWhatIs: 'Qué es',
        colHowCalculated: 'Cómo se calcula',
        detailTotalLeaders: 'Personas con al menos un reporte directo dentro del alcance consultado.',
        detailTeamSize: 'Suma de los reportes directos de todos los líderes del listado.',
        detailTeamReceived: 'Reconocimientos recibidos por las personas que integran esos equipos.',
        detailTeamSent: 'Reconocimientos enviados por las personas que integran esos equipos.',
        detailLeaderReceived: 'Reconocimientos recibidos por los líderes mismos, sin contar a su equipo.',
        detailLeaderSent: 'Reconocimientos enviados por los líderes mismos, sin contar a su equipo.',
        detailRatio: 'Reconocimientos de equipo recibidos divididos entre enviados.',
        detailParticipation: 'Promedio de participación de los equipos de líderes.',
        whatTeamSize: 'Cuántas personas le reportan directamente a ese líder.',
        howTeamSize: 'Conteo de personas cuyo manager es el líder. No cascadea los niveles inferiores del organigrama.',
        whatTeamReceived: 'Cuántos reconocimientos recibió en total la gente del equipo de ese líder, de cualquier persona.',
        howTeamReceived: 'Suma de reconocimientos donde el receptor pertenece al equipo directo del líder.',
        whatTeamSent: 'Cuántos reconocimientos envió en total la gente del equipo de ese líder, a cualquier persona.',
        howTeamSent: 'Suma de reconocimientos donde el emisor pertenece al equipo directo del líder.',
        whatLeaderReceived: 'Cuántos reconocimientos recibió en total el líder, de cualquier persona.',
        howLeaderReceived: 'Conteo de reconocimientos donde el receptor es el líder. No incluye a su equipo.',
        whatLeaderSent: 'Cuántos reconocimientos envió el líder, a cualquier persona.',
        howLeaderSent: 'Conteo de reconocimientos donde el emisor es el líder. No incluye a su equipo.',
        whatRatio: 'Qué tanto más reconocimiento recibe un equipo, comparado con lo que reconoce hacia otros.',
        howRatio: 'Reconocimientos de equipo recibidos divididos entre enviados. «—» si el equipo no envió ninguno.',
        whatParticipation: 'Qué porcentaje del equipo de ese líder ha reconocido a alguien al menos una vez.',
        howParticipation: 'Personas del equipo con al menos 1 reconocimiento enviado, divididas entre el tamaño del equipo. Recibir no cuenta: es una acción de otra persona.',
        whatLeader: 'Empleado que tiene personal a su cargo en la plantilla de la compañía.',
        howLeader: 'Toda persona con al menos un reporte directo. El resumen suma los líderes de todas las geografías del alcance consultado.',
        whatLevel: 'Profundidad del líder en el organigrama: N-1 es la raíz (sin manager), N-2, N-3… hacia abajo.',
        howLevel: 'Cadena de managers hasta la raíz + 1, calculada sobre toda la compañía y no solo entre los líderes visibles en este listado.',
      },
    },
    moderation: {
      title: 'Moderación',
      subtitle: 'Detalle de reconocimientos reportados. Incluye datos de contacto para escalamiento.',
      total: 'Reportes totales',
      pending: 'Pendientes',
      hidden: 'Ocultos',
      restored: 'Restaurados',
      colReported: 'Reportado',
      colReportedEmail: 'Email reportado',
      colOu: 'OU',
      colCountry: 'País',
      colReporter: 'Reportante',
      colReporterEmail: 'Email reportante',
      colReason: 'Motivo',
      colStatus: 'Estado',
      colDate: 'Fecha',
      statusPending: 'Pendiente',
      statusHidden: 'Oculto',
      statusRestored: 'Restaurado',
      statusPublished: 'Publicado',
      colComment: 'Comentario reportado',
      colLanguage: 'Idioma',
      colReportCount: '# Reportes',
      export: 'Exportar a Excel',
    },
    campaigns: {
      title: 'Historial de campañas',
      subtitle: 'Todas las campañas (activas y expiradas): audiencia y reconocimientos.',
      search: 'Buscar por nombre…',
      // D4 — selector de categoría (Fundamentales/Brillamos/Personalizada) que reemplazó al export
      // combinado de la tabla.
      filterTypeLabel: 'Categoría',
      filterAllTypes: 'Todas las categorías',
      summaryParticipants: 'Total de participantes',
      summaryRate: '% de participación',
      colName: 'Nombre',
      colType: 'Tipo',
      colStatus: 'Estado',
      colAudience: 'Audiencia (personas)',
      colRecognitions: 'Reconocimientos',
      // C2 — «Participación por Campaña» (rep-panel-campgeneral).
      colParticipants: 'Participantes',
      colRate: 'Tasa de participación',
      colAvgUser: 'Promedio por participante',
      colAvgUserHelp: 'Reconocimientos promedio que generó cada participante de la campaña: reconocimientos ÷ participantes.',
      dominantFundamentalTooltip: 'Fundamental más reconocido: {{name}}',
      colExpiration: 'Fecha de expiración',
      colActions: 'Acciones',
      prevPage: 'Anterior',
      nextPage: 'Siguiente',
      pageOf: 'Página {{page}} de {{total}}',
      type: {
        Fundamentales: 'Fundamentales',
        Brillamos: 'Brillamos',
        Personalizada: 'Personalizada',
      },
      status: {
        activo: 'Activo',
        finalizada: 'Expirada',
        borrador: 'Borrador',
      },
      // D3 — Reportería deja de ofrecer pausar/relanzar/enviar-a-aprobación (esa máquina de estados
      // vive en el editor de campañas, `admin.campaigns`). Queda una sola acción por fila: descargar
      // el Excel de esa campaña.
      downloadExcel: 'Descargar Excel',
      // D6 — error visible al usuario cuando falla el export por campaña (red/backend), vía Toast.
      downloadError: 'No se pudo descargar el Excel de la campaña.',
    },
  },
  // ── D5 Pass-C — Preferencias, equipo, tablero, leaderboard, campaña personalizada ──
  notifPrefs: {
    title: 'Notificaciones',
    subtitle: 'Elige qué avisos quieres recibir por correo.',
    unavailable: 'No se pudieron cargar tus preferencias.',
    emailEnabled: 'Recibir correos',
    emailHint: 'Interruptor general de todos los correos.',
    saveError: 'No se pudieron guardar tus preferencias.',
    cat: {
      recognitionReceived: 'Reconocimientos recibidos',
      streakAndBadges: 'Rachas e insignias',
      campaigns: 'Campañas',
      digest: 'Resumen de actividad',
    },
    catHint: {
      recognitionReceived: 'Cuando alguien te reconoce.',
      streakAndBadges: 'Tu racha e insignias desbloqueadas.',
      campaigns: 'Novedades de campañas Brillamos.',
      digest: 'Resumen periódico de tu actividad.',
    },
    catLockedAntiSpoiler: 'Bloqueado mientras el Modo Anti-Spoiler esté activo: no podemos avisarte de tus reconocimientos hasta que termine la campaña.',
  },
  team: {
    mostRecognized: 'Más Reconocidos', mostRecognizers: 'Más Reconocedores',
    title: 'Mi equipo',
    subtitle: 'Participación de tu equipo en el reconocimiento.',
    subtitleFor: 'Equipo de {{name}}',
    empty: 'Aún no hay actividad de tu equipo.',
    teamSize: 'Tamaño del equipo',
    sent: 'Enviados',
    received: 'Recibidos',
    participation: 'Participación',
    members: 'Miembros del equipo',
    emptyMembers: 'No hay miembros para mostrar.',
    colMember: 'Miembro',
    colSent: 'Enviados',
    colReceived: 'Recibidos',
    colStreak: 'Racha',
    noStreak: 'Sin racha',
    explore: 'Explorar su equipo',
    myTeam: 'Mi equipo',
    breadcrumb: 'Ruta de equipos',
    colTopFundamental: 'Top Fundamental',
    // La celda lleva las DOS lecturas etiquetadas: por lo que RECONOCEN a la persona (el dato
    // que existe para todo el equipo) y lo que ella usa al reconocer (UAT 18-ago-2026).
    fundRecibido: 'Le reconocen por:',
    fundEnviado: 'Reconoce por:',
    colActions: 'Acciones',
    viewButton: 'Ver perfil de {{name}}',
    viewButton_short: 'Ver',
    backToTeam: 'Volver al equipo',
    backToProfile: 'Volver a mi perfil',
    expandMember: 'Ver detalle de {{name}}',
  },
  tablero: {
    title: 'Tablero ejecutivo',
    subtitle: 'KPIs del Programa de Reconocimiento. Nunca muestra puntos.',
    empty: 'No hay KPIs para el alcance seleccionado.',
    // RF-143 (C4) — drill-down por Fundamental y por generación.
    allFundamentals: 'Todos los Fundamentales',
    allGenerations: 'Todas las generaciones',
    notApplicableNote: 'Con el filtro de generación, los KPIs que se calculan sobre el total de plantilla aparecen como «n/a»: el censo no se desglosa por generación, así que ese porcentaje significaría otra cosa.',
    // 🔴 Las CLAVES son los valores exactos de GenerationHelper (UserAdminService); solo se
    //    traduce el rótulo. Cambiar una clave dejaría el filtro sin casar con nadie.
    generations: {
      GenAlpha: 'Generación Alfa',
      GenZ: 'Generación Z',
      Millennial: 'Millennials',
      GenX: 'Generación X',
      BabyBoomer: 'Baby Boomers',
      Silent: 'Generación Silenciosa',
    },
  },
  leaderboard: {
    title: 'Ranking por OU',
    subtitle: 'Nominaciones por unidad organizativa/país.',
    noOu: 'Sin OU',
    you: ' (tú)',
  },
  campaignType: {
    personalizada: 'Campaña personalizada',
  },
  campaignLanding: {
    customNote: 'Esta es una campaña informativa. Explora sus documentos y micrositio.',
  },
  innovacion: {
    kpiStreak: 'Racha',
    kpiStreakHint: 'récord: {{record}} semanas',
    kpiStreakHintMonthly: 'récord: {{record}} meses',
    kpiNominations: 'Nominaciones',
    kpiNominationsHint: 'Enviadas en esta campaña',
    kpiNominationsHint2: '{{count}} personas distintas',
    kpiUnique: 'Personas nominadas',
    kpiUniqueHint: 'Receptores únicos',
    kpiDaysLeft: 'Días restantes',
    suppressed: 'Los datos están suprimidos por privacidad: el grupo es demasiado pequeño para mostrar cifras.',
    kpisUnavailable: 'Los KPIs en vivo no están disponibles por ahora.',
    fundamentalsTitle: 'Fundamentales de esta campaña',
    nominateSecondary: 'Ir a la página de Nominar',
    recentTitle: 'Reconocimientos recientes',
    recentEmpty: 'Aún no hay reconocimientos en esta campaña.',
    noCampaign: 'No hay ninguna campaña personalizada activa. Se puede crear desde Administración → Campañas.',
  },
};

export default recognition;
